import { Injectable } from '@angular/core';
import {
    AddCommentTaskDto,
    CommentTaskDto,
    DraftedTimesheetDto,
    DropdownProjectListDto,
    GetAllProjectTimeSheetDto,
    GetAllTaskDto,
    IncludeTimesheetDto,
    InputeCreateOrEditTimesheetDto,
    ProjectBillingType,
    ProjectLevelCommentDto,
    ProjectTeamCreateOrEditDto,
    ProjectTimesheetFrequencyEnum,
    SendForApprovalTimesheetDto,
    TaskLogOutPutDto,
    TimeSheetDto,
    TimesheetFrequencyDto,
    TimesheetServiceProxy,
    TimesheetAndApprovalStatusEnum,
    TimesheetApprovalDto,
    ApproveRejectTimesheetDto,
    TaskListDto,
    ProjectLevelShowInTimesheetDto,
    ViewSummaryDto,
    UserReminderDto,
    SendReminderDto,
    UserAndTimesheetStatus,
    IsCheckTimesheetFlag,
    SendTimesheetToClient,
    ProjectListViewSummaryDto,
    AddTimesheetLevelCommentDto,
    GetTimesheetLevelCommentDto,
    PagedResultDtoOfTimeSheetDto,
    // TeamTimesheetStatsDto,
    TimesheetStatesDto,
    MyTimesheetStatsDto,
    OverAllSummaryDto,
    EmployeeWiseSummaryDto,
    OverAllSummaryRootDto,
    OverAllSummarySheetReport,
    AttendanceReportOverAllSummaryDto,
    AttendanceReportEmployeeWiseDto,
    AttendanceReportDto,
    TimeOffReportDto,
    TimeOffASummaryDto,
    TimeOffDetailReport,
    MyTimesheetGridDto,
    TeamTimesheetHeaderFiledDto,
    WorkStatusUser,
    WorkFromType,
    ProductivityBarReportDto,
    NotFIllTImesheet,    
} from "@shared/service-proxies/service-proxies";
import moment from 'moment';
import { Observable, of, Subject } from 'rxjs';
import { TimesheetUtilityService } from './timesheet-utility.service';
import { map } from 'rxjs/operators';
import { DateTime } from 'luxon';
import * as xlsx from "xlsx-js-style";
import * as _ from 'lodash';
import { TaskStateEnum } from '@app/main/time-tracking/models/taskState.enum';
import { AbpSessionService } from 'abp-ng2-module';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { formatDate } from 'ngx-bootstrap/chronos';
import { exportDataGrid } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { AppConsts } from '@shared/AppConsts';
declare const require: any;
// const jsPDF = require("jspdf");
// require("jspdf-autotable");
const FileSaver = require("file-saver");

@Injectable()
export class TimesheetService {
    dateTime = new Date();
    msg: string;


    constructor(private _abpSessionService: AbpSessionService, public datepipe: DatePipe,
        private _monitorService: MonitoringService, private _tsProxy: TimesheetServiceProxy, private _tus: TimesheetUtilityService) { }

    commentBarHidden = new Subject<number>();

    //Navigation from Dashboard
    navigatedashboard = new Subject<boolean>();

    // used to load the timesheet detail view based on the range selected in project view
    timesheetDetailCurrentDateRepo: Date;



    //Method to mark all commments as read
    async markAllCommentsAsRead(commentIds: number[]) {
        for (let i = 0; i < commentIds.length; i++) {
            let x = new AddCommentTaskDto();
            x.commentId = commentIds[i];
            await this._tsProxy.updateCommentTask(x).toPromise();
        }
    }

    //Method to get billability Status
    billabilityStatus(status: ProjectBillingType) {
        if (status == ProjectBillingType.Billable) return [{ billabilityId: 1, billabilityName: "Billable" }, { billabilityId: 2, billabilityName: "Non-Billable" }];
        else if (status == ProjectBillingType.NonBillable) return [{ billabilityId: 1, billabilityName: "Billable" }, { billabilityId: 2, billabilityName: "Non-Billable" }];
    }

    //Method to get all project details
    getAllProjects(projectId: number[], billableType: ProjectBillingType, filter: string, dateInWeek: Date): Observable<GetAllProjectTimeSheetDto[]> {
        let d = new Date();
        return this._tsProxy
            .getAllProjectListForTimeSheet(projectId, billableType, filter, this._tus.getWeekStringArray(dateInWeek, "DD MMMM YYYY"), d.getTimezoneOffset())
            .pipe(
                map((r) => {
                    r.forEach((x) => {
                        this._tus.modifyDayTimeStamps(x.daysListDtos);
                    });
                    return r.sort((a, b) => b.projectCreationDate.toJSDate().getTime() - a.projectCreationDate.toJSDate().getTime());
                })
            );
    }


    //Method to get timesheet task
    getTimesheetTasks(
        projectId: number,
        billabilityFilter: ProjectBillingType,
        filterSearch: string,
        dateInWeek: Date,
        timesheet: TimeSheetDto,
        timesheetRange: Date[],
        timesheetFrequency: ProjectTimesheetFrequencyEnum,
        invoicetimesheetFrequency: ProjectTimesheetFrequencyEnum,
        isMyTimesheet?: boolean
    ): Observable<GetAllTaskDto[]> {
        try {            
            this._monitorService.logTrace("UI-getTimesheetTasks", { "getTimesheetTasks ": "getTimesheetTasks:getAllMyTimesheetTaskByProjectId called " + this.msg + this.dateTime });
            let obs: Observable<GetAllTaskDto[]>;
            let d = new Date();
            
            if (timesheet) {
                if (isMyTimesheet) {
                    obs = this._tsProxy.getAllMyTimesheetTaskByProjectId(
                        projectId,
                        timesheet.id,
                        0,
                        invoicetimesheetFrequency == ProjectTimesheetFrequencyEnum.Weekly ? this._tus.getWeekStringArray(dateInWeek, "DD MMMM YYYY") :
                        invoicetimesheetFrequency == ProjectTimesheetFrequencyEnum.BiMonthly? this._tus.getBiMonthlyStringArray(new Date(timesheetRange[0]), new Date(timesheetRange[1]), "DD MMMM YYYY") : this._tus.getMonthStringArray(dateInWeek, "DD MMMM YYYY"),
                        timesheetRange ? DateTime.fromJSDate(timesheetRange[0]) : undefined,
                        timesheetRange ? DateTime.fromJSDate(timesheetRange[1]) : undefined,
                        timesheetFrequency,
                        d.getTimezoneOffset()
                    );
                } else {
                    obs = this._tsProxy.getAllMyTimesheetTaskByProjectId(
                        projectId,
                        timesheet.id,
                        timesheet.userId,
                        invoicetimesheetFrequency == ProjectTimesheetFrequencyEnum.Weekly ? this._tus.getWeekStringArray(dateInWeek, "DD MMMM YYYY") :
                        invoicetimesheetFrequency == ProjectTimesheetFrequencyEnum.BiMonthly? this._tus.getBiMonthlyStringArray(new Date(timesheetRange[0]), new Date(timesheetRange[1]), "DD MMMM YYYY") : this._tus.getMonthStringArray(dateInWeek, "DD MMMM YYYY"),
                        timesheetRange ? DateTime.fromJSDate(timesheetRange[0]) : undefined,
                        timesheetRange ? DateTime.fromJSDate(timesheetRange[1]) : undefined,
                        timesheetFrequency,
                        d.getTimezoneOffset()
                    );
                }
            } else {
                obs = this._tsProxy.getAllTaskByProjectId(
                    projectId,
                    this._tus.getBiMonthlyStringArray(new Date(timesheetRange[0]), new Date(timesheetRange[1]), "DD MMMM YYYY"),
                    filterSearch,
                    billabilityFilter,
                    timesheetRange ? DateTime.fromJSDate(timesheetRange[0]) : undefined,
                    timesheetRange ? DateTime.fromJSDate(timesheetRange[1]) : undefined,
                    timesheetFrequency,
                    d.getTimezoneOffset()
                );
            }

            return obs.pipe(
                map((r) => {
                    r.forEach((x) => {
                        this._tus.modifyDayTimeStamps(x.daysListDtos);
                    });
                    return r;
                })
            );
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }


    //Method to get tasks for month
    getTasksForMonth(
        dateInMonth: Date,
        project: GetAllProjectTimeSheetDto,
        timesheetFrequency: ProjectTimesheetFrequencyEnum
    ): Observable<GetAllTaskDto[]> {
        let monthArray = this._tus.getMonthStringArray(dateInMonth, "DD MMMM YYYY");
        return this._tsProxy.getTimesheetMonthlyView(project.projectId, monthArray, undefined, undefined, undefined, undefined, timesheetFrequency);
    }

     //Method to get tasks for month
     getTasksForMonths(
        dateInMonth: Date,
        project,
        timesheetFrequency: ProjectTimesheetFrequencyEnum
    ): Observable<GetAllProjectTimeSheetDto[]> {
        let monthArray = this._tus.getMonthStringArray(dateInMonth, "DD MMMM YYYY");
        // let projecIds = project.length === 0 ? undefined : project.map(x => x.projectId);
        return this._tsProxy.getAllMonthlyProjectViewForTimesheet(undefined, undefined,undefined, monthArray, new Date().getTimezoneOffset());
    }


    //Method to send time reminder.
    sendReminders(
        projectName: string,
        fromDate: DateTime,
        toDate: DateTime,
        notifcationMessage: string,
        selectedUsers: UserReminderDto[]
    ): Observable<void> {
        let sendReminderDto = new SendReminderDto();
        sendReminderDto.projectName = projectName;
        sendReminderDto.timesheetFromDate = fromDate;
        sendReminderDto.timesheetToDate = toDate;
        sendReminderDto.notificationMessage = notifcationMessage;
        sendReminderDto.userTimesheetStatus = selectedUsers.map((r) => {
            let userTimesheetStatusItem = new UserAndTimesheetStatus();
            userTimesheetStatusItem.userIds = r.userId;
            userTimesheetStatusItem.timesheetId = r.timesheetId;
            userTimesheetStatusItem.timesheetStatus = r.timesheetStatus;
            return userTimesheetStatusItem;
        });
        return this._tsProxy.sendReminder(sendReminderDto);
    }

    //Method to get timesheet details
    getMytimesheets(
        projectIds: number[],
        timesheetStatus: TimesheetAndApprovalStatusEnum,
        dateRangeFilter: Date[],
        maxResultCount: number,
        skipCount: number,
        sortByNewestOnTop: boolean,
        timesheetId?: number
    ): Observable<MyTimesheetGridDto> {
        return this._tsProxy.getAllTimeSheets(
            undefined,
            projectIds,
            false,
            abp.session.tenantId,
            undefined,
            timesheetStatus,
            timesheetId ? timesheetId : 0,
            dateRangeFilter ? DateTime.fromJSDate(dateRangeFilter[0]) : undefined,
            dateRangeFilter ? DateTime.fromJSDate(dateRangeFilter[1]) : undefined,
            sortByNewestOnTop, false,
            maxResultCount,
            skipCount,
            undefined
        );


        
    }


    //Method to get team timesheet details
    getTeamTimesheets(
        projectIds: number[],
        userIds: number[],
        timesheetStatusFilter: TimesheetAndApprovalStatusEnum,
        dateRangeFilter: Date[],
        isSummary: boolean,
        maxResultCount: number,
        skipCount: number,
        sortByNewestOnTop: boolean,
        timesheetId?: number,
        includeMine?: boolean,
        isExport?: boolean,

    ): Observable<PagedResultDtoOfTimeSheetDto> {
        return this._tsProxy.getTeamsTimeSheet(
            undefined,
            projectIds,
            dateRangeFilter && dateRangeFilter[0] ? DateTime.fromJSDate(dateRangeFilter[0]) : undefined,
            dateRangeFilter && dateRangeFilter[1] ? DateTime.fromJSDate(dateRangeFilter[1]) : undefined,
            timesheetId ? timesheetId : 0,
            includeMine ? includeMine : false,
            sortByNewestOnTop,
            timesheetStatusFilter,
            isSummary,
            isExport,
            maxResultCount,
            skipCount,
            undefined
        );
    }


    //Method to get timesheet by Id
    getTimeSheetById(userId: number, sortByNewestOnTop: boolean, timesheetId: number): Observable<PagedResultDtoOfTimeSheetDto> {
        return this._tsProxy.getUserTimeSheetById(
            [userId],
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            timesheetId,
            undefined,
            undefined,
            sortByNewestOnTop,
            undefined,
            undefined,
            undefined, undefined
        );
    }


    //Method to get user specific timesheet stats
    getMyTimesheetStats(
        projectIds: number[],
        userIds: number[],
        timesheetStatusFilter: TimesheetAndApprovalStatusEnum,
        dateRangeFilter: Date[]
    ): Observable<MyTimesheetStatsDto> {
        return this._tsProxy.getMyTimesheetStats(
            userIds,
            projectIds,
            timesheetStatusFilter,
            dateRangeFilter && dateRangeFilter[0] ? DateTime.fromJSDate(dateRangeFilter[0]) : undefined,
            dateRangeFilter && dateRangeFilter[1] ? DateTime.fromJSDate(dateRangeFilter[1]) : undefined
        );
    }

    //Method to get user team timesheet stats
    getTeamTimesheetStats(): Observable<number> {
        return this._tsProxy.getTeamTimesheetStats();
    }
    getTeamTimesheetStatsNew(): Observable<TeamTimesheetHeaderFiledDto> {
        return this._tsProxy.getTeamTimesheetHeaderDetails();
    }


    //Method to add comment in timesheet level wise
    addTimesheetLevelComment(selectedTimesheets: TimeSheetDto[], comment: string): Observable<void> {
        let arr = [];
        for (let i = 0; i < selectedTimesheets.length; i++) {
            let commentDto = new AddTimesheetLevelCommentDto();
            commentDto.myTimeSheetId = selectedTimesheets[i].id;
            commentDto.tenantId = abp.session.tenantId;
            commentDto.userId = abp.session.userId;
            commentDto.comments = comment;
            arr.push(commentDto);
        }
        return this._tsProxy.addTimesheetLevelComments(arr);
    }

    //Method  to get timesheet comments level wise
    getTimesheetLevelComment(tenantId: number, timesheetId: number): Observable<GetTimesheetLevelCommentDto[]> {
        return this._tsProxy.getTimesheetLevelComments(undefined, tenantId, timesheetId, undefined);
    }

    //Method to approve timesheet group
    approveTimesheetGroup(approve: boolean, timesheetIds: number[]): Observable<void> {
        let sendTimesheetToClient = new SendTimesheetToClient();
        sendTimesheetToClient.timesheetId = timesheetIds;
        return this._tsProxy.approvedTimesheetSendToClient(sendTimesheetToClient);
    }


    //Method to set time
    setZeroTimeForLocalDate(date: Date): Date {

        date.setHours(0, 0, 0, 0);

        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);

    }

    //Method for timesheet Approvals
    submitTimesheetForApproval(
        projectId: number,
        tasksIncludedInTimesheet: IncludeTimesheetDto[],
        timesheetRange: Date[],
        timesheetType: ProjectTimesheetFrequencyEnum,
        submittedHours?: string,
        timesheetId?: number,
        timesheetIdArray?: number[],
        timesheetSubmissionInvoiceRange?: Date[]
    ): Observable<IsCheckTimesheetFlag> {
        let d = new Date();
        let sendForApprovalTimesheetDtoArray: SendForApprovalTimesheetDto[] = [];
        timesheetIdArray.forEach(x => {
            let sendForApprovalTimesheetDto = new SendForApprovalTimesheetDto();
            sendForApprovalTimesheetDto.projectId = projectId;
            sendForApprovalTimesheetDto.fromDate = DateTime.fromJSDate(timesheetRange[0]);
            sendForApprovalTimesheetDto.toDate = DateTime.fromJSDate(timesheetRange[1]);
            sendForApprovalTimesheetDto.timeSheetDate = DateTime.fromJSDate(timesheetRange[0]);
            sendForApprovalTimesheetDto.submittedHours = submittedHours;
            sendForApprovalTimesheetDto.timesheetStatus = TimesheetAndApprovalStatusEnum.Pending;
            sendForApprovalTimesheetDto.timesheetType = timesheetType;
            sendForApprovalTimesheetDto.userId = abp.session.userId;
            sendForApprovalTimesheetDto.tenantId = abp.session.tenantId;
            sendForApprovalTimesheetDto.includeTimesheetDetails = tasksIncludedInTimesheet;
            sendForApprovalTimesheetDto.timesheetId = x;
            sendForApprovalTimesheetDto.currentTime = DateTime.fromJSDate(this.setZeroTimeForLocalDate(d));
            sendForApprovalTimesheetDto.timesheetInvoiceFromDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[0]);
            sendForApprovalTimesheetDto.timesheetInvoiceToDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[1]);
            sendForApprovalTimesheetDtoArray.push(sendForApprovalTimesheetDto);
        });
            let sendForApprovalTimesheetDto = new SendForApprovalTimesheetDto();
            sendForApprovalTimesheetDto.projectId = projectId;
            sendForApprovalTimesheetDto.fromDate = DateTime.fromJSDate(timesheetRange[0]);
            sendForApprovalTimesheetDto.toDate = DateTime.fromJSDate(timesheetRange[1]);
            sendForApprovalTimesheetDto.timeSheetDate = DateTime.fromJSDate(timesheetRange[0]);
            sendForApprovalTimesheetDto.submittedHours = submittedHours;
            sendForApprovalTimesheetDto.timesheetStatus = TimesheetAndApprovalStatusEnum.Pending;
            sendForApprovalTimesheetDto.timesheetType = timesheetType;
            sendForApprovalTimesheetDto.userId = abp.session.userId;
            sendForApprovalTimesheetDto.tenantId = abp.session.tenantId;
            sendForApprovalTimesheetDto.includeTimesheetDetails = tasksIncludedInTimesheet;
            sendForApprovalTimesheetDto.timesheetId = timesheetId;
            sendForApprovalTimesheetDto.currentTime = DateTime.fromJSDate(this.setZeroTimeForLocalDate(d));
            sendForApprovalTimesheetDto.timesheetInvoiceFromDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[0]);
            sendForApprovalTimesheetDto.timesheetInvoiceToDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[1]);
        return timesheetId
            ? this._tsProxy.reSubmiteTimesheet(sendForApprovalTimesheetDtoArray)
            : this._tsProxy.sendForApprovalTimesheet(d.getTimezoneOffset(), sendForApprovalTimesheetDto);
    }


    //Method to get comment details for timesheet
    loadComments(taskId: number, projectId: number): Observable<CommentTaskDto[]> {
        if (taskId) return this._tsProxy.getTaskComment(abp.session.userId, abp.session.tenantId, taskId);
        if (projectId) return this._tsProxy.getProjectLevelComments(projectId);
    }

    //Method to add comment in timesheet approval
    addComment(comment: string, taskId: number, projectId: number): Observable<void> {
        if (taskId) {
            let commentDto = new AddCommentTaskDto();
            commentDto.comments = comment;
            commentDto.taskId = taskId;
            commentDto.userId = abp.session.userId;
            commentDto.tenantId = abp.session.tenantId;
            return this._tsProxy.addCommentTaskWise(commentDto);
        }
        if (projectId) {
            let commentDto = new ProjectLevelCommentDto();
            commentDto.projectId = projectId;
            commentDto.userId = abp.session.userId;
            commentDto.tenantId = abp.session.tenantId;
            commentDto.comment = comment;
            return this._tsProxy.addProjectLevelComment(commentDto);
        }
    }

    //Method to get task history details
    getTaskHistory(taskId: number, timesheet: TimeSheetDto,isMytimesheet :boolean , dateTime: DateTime): Observable<TaskLogOutPutDto> {
        try {
            this._monitorService.logTrace("UI-getTaskHistory", { "getTaskHistory ": "getTaskHistory: " + this + this.msg + this.dateTime });
          
          const userId = timesheet!== null && timesheet!== undefined && timesheet.userId !== null && timesheet.userId !== undefined ? timesheet.userId : abp.session.userId;
         
        
           return this._tsProxy.getTaskLogByTaskId(taskId,userId,isMytimesheet,dateTime);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    // my timesheet id will be passed in only when uer is editing his rejected timesheet
    saveTimesheet(projectId: number, taskId: number, editedTimespan: string, editedDate: Date, myTimesheetId?: number): Observable<void> {
        try {
            const draftedTimesheet = new DraftedTimesheetDto();
            draftedTimesheet.projectId = projectId;
            draftedTimesheet.userId = abp.session.userId;
            draftedTimesheet.tenantId = abp.session.tenantId;
            draftedTimesheet.userProjectTaskId = taskId;
            draftedTimesheet.manualAddTime = this._tus.addSecondsToTimespan(editedTimespan);
            draftedTimesheet.manualAddDate = DateTime.fromJSDate(new Date(editedDate.getTime() - editedDate.getTimezoneOffset() * 60 * 1000));
            draftedTimesheet.myTimeSheetId = myTimesheetId;
            return myTimesheetId ? this._tsProxy.editMyTimesheet(draftedTimesheet) : this._tsProxy.createOrEditDraftTimesheet(draftedTimesheet);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to get timesheet stats
    getTimesheetStats(projectId: number, userId: number): Observable<TimesheetFrequencyDto> {
        return this._tsProxy.getEstimatedBillableLoggedBillableRemaining(projectId, userId);
    }

    //Method to get project timesheet stats
    getProjectTimesheetStats(projectId: number, userId: number, timesheetId: number[], tsStartDate: DateTime, tsEndDate: DateTime): Observable<TimesheetStatesDto> {
        if (timesheetId?.length) {
            return this._tsProxy.getSubmittedTimesheetStates(timesheetId);
        }
        return this._tsProxy.getDraftedTimesheetStates(projectId, userId, tsStartDate, tsEndDate, false);
    }

    //Method to get project summary details
    getProjectsummaryDetails(projectId: number,skip:number,take:number): Observable<ViewSummaryDto[]> {
        try { return this._tsProxy.getProjectViewSummaryV2(projectId,skip,take); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to get List of users to send reminders
    getListOfUsersToSendReminders(projectId: number, fromDate: DateTime, toDate: DateTime): Observable<UserReminderDto[]> {
        try { return this._tsProxy.getReminderUserList(projectId, fromDate, toDate); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to approve or reject timesheet
    approveOrRejectTimesheet(approve: boolean, timesheetId: number, timesheetSubmissionInvoiceRange: Date[], timeSheet: TimeSheetDto): Observable<void> {
        const approveOrRejectTimesheetDto = new ApproveRejectTimesheetDto();
        approveOrRejectTimesheetDto.userId = abp.session.userId;
        approveOrRejectTimesheetDto.tenantId = abp.session.tenantId;
        approveOrRejectTimesheetDto.timesheetId = timesheetId;
        approveOrRejectTimesheetDto.timesheetInvoiceFromDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[0]);
        approveOrRejectTimesheetDto.timesheetInvoiceToDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[1]);
        approveOrRejectTimesheetDto.timesheetStatus = approve ? TimesheetAndApprovalStatusEnum.Approved : TimesheetAndApprovalStatusEnum.Rejected;
        if(timeSheet.dateWiseTimesheetIds.find(t=> t.timesheetId == timesheetId)?.approvalLevelTimesheetStatus == TimesheetAndApprovalStatusEnum.Approved && !approve) {
            this._tsProxy.timesheetUpdateStatusApproveAfterReject(abp.session.userId,[timesheetId]).subscribe(x =>{ });
        }
        return this._tsProxy.timesheetApproveReject([approveOrRejectTimesheetDto]);
    }
    approveOrRejectTimesheetArray(approve: boolean, timesheetFrequency: ProjectTimesheetFrequencyEnum,timesheetId: number[], timeSheet: TimeSheetDto, timesheetSubmissionInvoiceRange: Date[], selectedUniqueTimesheetByIdArray?): Observable<void> {
        let approveOrRejectTimesheetDtoArray: ApproveRejectTimesheetDto[] = [];
        let timesheetIds = [];
        timesheetId.forEach(x => {
            let approveOrRejectTimesheetDto = new ApproveRejectTimesheetDto();
            approveOrRejectTimesheetDto.userId = abp.session.userId;
            approveOrRejectTimesheetDto.tenantId = abp.session.tenantId;
            approveOrRejectTimesheetDto.timesheetId = x;
            approveOrRejectTimesheetDto.timesheetType = timesheetFrequency
            if (selectedUniqueTimesheetByIdArray?.length) approveOrRejectTimesheetDto.timeSheetDate = selectedUniqueTimesheetByIdArray.find(item => x === item.timesheetId)?.timesheetSubmitDate;
            approveOrRejectTimesheetDto.timesheetStatus = approve ? TimesheetAndApprovalStatusEnum.Approved : TimesheetAndApprovalStatusEnum.Rejected;
            approveOrRejectTimesheetDto.timesheetInvoiceFromDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[0]);
            approveOrRejectTimesheetDto.timesheetInvoiceToDate = DateTime.fromJSDate(timesheetSubmissionInvoiceRange[1]);
            approveOrRejectTimesheetDtoArray.push(approveOrRejectTimesheetDto);
            if(timeSheet.dateWiseTimesheetIds.find(t=> t.timesheetId == x)?.approvalLevelTimesheetStatus == TimesheetAndApprovalStatusEnum.Approved && !approve) {
                timesheetIds.push(x);
            }
        });
        this._tsProxy.timesheetUpdateStatusApproveAfterReject(abp.session.userId,timesheetIds).subscribe(x =>{ });
       
        return this._tsProxy.timesheetApproveReject(approveOrRejectTimesheetDtoArray);
    }

    //Method to get week day headers
    getWeekDayHeaders(dayInTheWeekToLoad: Date, timesheetSubmissionInvoiceRange?: Date[]): string[] {
        try { return this._tus.getWeekStringArray(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getWeekDayHeadersForProjectTimesheet(dayInTheWeekToLoad: Date): string[] {
        try { return this._tus.getWeekStringArrayForTimesheetProject(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getBiMonthlyWeeksDayHeaders(dayInTheWeekToLoad: Date): string[] {
        try { return this._tus.getBimonthlyWeekStringArray(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getBiMonthlyWeeksDayHeadersForProjectTimesheet(dayInTheWeekToLoad: Date): string[] {
        try { return this._tus.getBimonthlyWeekStringArrayTimesheetProjectView(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getMonthlyWeeksDayHeaders(dayInTheWeekToLoad: Date): string[] {
        try { return this._tus.getMonthStringArray(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getMonthlyWeeksDayHeadersForProjectTimesheet(dayInTheWeekToLoad: Date): string[] {
        try { return this._tus.getMonthStringArrayForTimesheetProjectView(dayInTheWeekToLoad, "MMM DD"); }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    getCurrentDayStr() {
        return moment(new Date()).format("MMM DD");
    }

    getSelectedDayStr(selectedDate: Date) {
        if (!selectedDate) return null;
        return moment(new Date(selectedDate.toString())).format("MMM DD");
    }

    initializeWeekdayHeaders(): { dayShort: string; dateStr: string; key: string; total: number }[] {
        return [
            { dayShort: "Mon", dateStr: null, key: "monday", total: 0 },
            { dayShort: "Tue", dateStr: null, key: "tuesday", total: 0 },
            { dayShort: "Wed", dateStr: null, key: "wednesday", total: 0 },
            { dayShort: "Thu", dateStr: null, key: "thursday", total: 0 },
            { dayShort: "Fri", dateStr: null, key: "friday", total: 0 },
            { dayShort: "Sat", dateStr: null, key: "saturday", total: 0 },
            { dayShort: "Sun", dateStr: null, key: "sunday", total: 0 },
        ];
    }

    getApprovalHistory(timesheetId: number): Observable<TimesheetApprovalDto[]> {
        return this._tsProxy.getApprovalHistory(timesheetId);
    }

    sendTimesheetsToClient(timesheetIds: number[]): Observable<void> {
        let sendTimesheetToClientDto = new SendTimesheetToClient();
        sendTimesheetToClientDto.timesheetId = timesheetIds;
        return this._tsProxy.approvedTimesheetSendToClient(sendTimesheetToClientDto);
    }

    saveShowInTimesheetValue(
        showInTimesheet: boolean,
        projectId: number,
        taskId: number,
        timesheetFrequency: ProjectTimesheetFrequencyEnum,
        timesheetId: number
    ): Observable<void> {
        let projectLevelShowInTimesheetDto = new ProjectLevelShowInTimesheetDto();
        projectLevelShowInTimesheetDto.includeInTimesheet = showInTimesheet;
        projectLevelShowInTimesheetDto.projectId = projectId;
        projectLevelShowInTimesheetDto.timesheetFrequency = timesheetFrequency;
        projectLevelShowInTimesheetDto.userProjectTaskId = taskId;
        projectLevelShowInTimesheetDto.userId = abp.session.userId;
        projectLevelShowInTimesheetDto.tenantId = abp.session.tenantId;
        projectLevelShowInTimesheetDto.timeSheetId = timesheetId;
        return this._tsProxy.createProjectLevelShowInTimeSheet(projectLevelShowInTimesheetDto);
    }

    isTimesheetApprovar() {
        return this._tsProxy.isTimeSheetApprovar(null);
    }

    //Method to create excel on timesheet details
    async exportToExcelWithTimesheets(timesheets: TimeSheetDto[], projectId: number) {
        try {
            this._monitorService.logTrace("UI-exportToExcelWithTimesheets", { "exportToExcelWithTimesheets ": "exportToExcelWithTimesheets:action " + this + this.dateTime });
            // get the submission frequency for the project
            let submissionFrequency = await (await this.getTimesheetStats(projectId, timesheets[0].userId).toPromise()).submissionFrequency;
            // Find uique user ids in all the timesheets
            let usersInTimesheet = _.uniqBy(timesheets, (x) => x.userId).map((r) => r.userId);
            let userWiseTimesheeet: TimeSheetDto[][] = [];
            // iterate through the unique user ids and create 2d array with each item as an array of timesheets for the user
            for (let i = 0; i < usersInTimesheet.length; i++) {
                let timesheetsForUser = timesheets.filter((r) => r.userId === usersInTimesheet[i]);
                userWiseTimesheeet.push(timesheetsForUser);
            }
            // initialize a new workbook
            const wb: xlsx.WorkBook = xlsx.utils.book_new();
            // Add summary tab
            const summaryws: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            xlsx.utils.book_append_sheet(wb, summaryws, "Summary");
            // iterate through the 2d array and generate a workbook for every user
            // all timesheets for the user will be clubbed into a single worksheet
            let userSummaryArray: SummaryTimesheetForUser[] = [];
            for (let i = 0; i < userWiseTimesheeet.length; i++) {
                let data = await this.createWorksheetForOneUser(userWiseTimesheeet[i], submissionFrequency, projectId);
                const ws = data.worksheet;
                userSummaryArray.push(data.summary);
                this.styleUserWorkSheet(ws);
                xlsx.utils.book_append_sheet(wb, ws, userWiseTimesheeet[i][0].userName);
            }
            this.createSummaryWorksheet(summaryws, timesheets, userSummaryArray);
            // export excel
            xlsx.writeFile(wb, `${_.capitalize(timesheets[0].projectName)} ${this._tus.getTimesheetDateRangeOnlyDates(timesheets[0])}.xlsx`);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to create employee wise timesheet report
    async exportToExcelEmployeeTimesheetReport(timesheets: EmployeeWiseSummaryDto[], projectId: number, projectName: string, reportName?: string) {
        try {
            this._monitorService.logTrace("UI-exportToExcelEmployeeTimesheetReport", { "exportToExcelEmployeeTimesheetReport ": "exportToExcelEmployeeTimesheetReport:action " + this + this.msg + this.dateTime })

            // if (timesheets?.length > 0) {
            // get the submission frequency for the project
            let submissionFrequency = timesheets[0].timesheetFrequency;
            // Find uique user ids in all the timesheets
            let usersInTimesheet = _.uniqBy(timesheets, (x) => x.userId).map((r) => r.userId);
            let userWiseTimesheeet: EmployeeWiseSummaryDto[][] = [];
            // iterate through the unique user ids and create 2d array with each item as an array of timesheets for the user
            for (let i = 0; i < usersInTimesheet.length; i++) {
                let timesheetsForUser = timesheets.filter((r) => r.userId === usersInTimesheet[i]);
                if (timesheetsForUser[0].employeeName.length > 30) { timesheetsForUser[0].employeeName = timesheetsForUser[0].employeeName.substring(0, Math.min(timesheetsForUser[0].employeeName.length, 30)); }
                userWiseTimesheeet.push(timesheetsForUser);
            }
            // initialize a new workbook
            const wb: xlsx.WorkBook = xlsx.utils.book_new();
            // Add summary tab
            if (userWiseTimesheeet?.length > 0) {
                for (let i = 0; i < userWiseTimesheeet.length; i++) {
                    let data = await this.createWorksheetForEachUser(userWiseTimesheeet[i], submissionFrequency, projectId);
                    const ws = data.worksheet;
                    this.styleUserWorkSheet(ws);
                    xlsx.utils.book_append_sheet(wb, ws, userWiseTimesheeet[i][0].employeeName);
                }

                // export excel
                // xlsx.writeFile(wb, `${_.capitalize(timesheets[0].projectName)} (Employee Timesheet Report).xlsx`);
            }
            // this.createSummaryWorksheet(summaryws, timesheets, userSummaryArray);
            if (reportName?.length > 0) {
                xlsx.writeFile(wb, `${_.capitalize(reportName)} (Employee Timesheet Report).xlsx`);
            }
            else {
                xlsx.writeFile(wb, `${_.capitalize(timesheets[0].projectName)} (Employee Timesheet Report).xlsx`);
            }


        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to create Worksheet for each user
    async createWorksheetForEachUser(
        timesheets: EmployeeWiseSummaryDto[],
        timesheetFrequency: ProjectTimesheetFrequencyEnum,
        projectId: number
    ): Promise<{ worksheet: xlsx.WorkSheet; summary: TimesheetReportForEmployee }> {
        try {
            this._monitorService.logTrace("UI-exportToExcelEmployeeTimesheetReport", { "exportToExcelEmployeeTimesheetReport ": "exportToExcelEmployeeTimesheetReport:action " + this + this.msg + this.dateTime })

            let timesheetJsonArrayForOneUser: TimesheetEmployeeReportJson[] = [];

            for (let i = 0; i < timesheets.length; i++) {
                let timesheet = timesheets[i];
                let datesArray = this._tus.getDatesArrayFromFrequencyForReport(timesheet, timesheetFrequency);
                let timesheetJsonArray = await this.getTimesheetReportJsonArray(datesArray, projectId, timesheet, timesheetFrequency);
                timesheetJsonArrayForOneUser = [...timesheetJsonArrayForOneUser, ...timesheetJsonArray];
            }

            let modifiedArray = timesheetJsonArrayForOneUser.map((r) => {
                let x = [];
                x.push(r.dateString);
                x.push(r.taskName);
                x.push(r.EstimatedHours);
                x.push(r.hoursSpent);
                x.push(r.Billability);
                x.push(r.status);
                x.push(r.timesheetStatus);
                return x;
            });

            let totalEstimatedTime = modifiedArray.reduce((a, v) => {
                a += this._tus.timestampToMinutes(v[2]);
                return a;
            }, 0);
            let totaltrackedTime = modifiedArray.reduce((a, v) => {
                a += this._tus.timestampToMinutes(v[3]);
                return a;
            }, 0);

            let timesheetFrequencyText: any;
            if (timesheetFrequency == 1) {
                timesheetFrequencyText = "BiMonthly";
            }
            else if (timesheetFrequency == 2) {
                timesheetFrequencyText = "Monthly";
            }
            else if (timesheetFrequency == 3) {
                timesheetFrequencyText = "Weekly";
            }
            else if (timesheetFrequency == 4) {
                timesheetFrequencyText = "Daily";
            }

            let summaryForUser = new TimesheetReportForEmployee();
            summaryForUser.member = timesheets[0].employeeName;
            summaryForUser.emailAddress = timesheets[0].emailAddress;
            summaryForUser.totalHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(totaltrackedTime));
            // summaryForUser.requiredHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheets[0].requiredHours)));
            // summaryForUser.BilledHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheets[0].billedHours)));

            modifiedArray.unshift(["Date", "Tasks", "Estimated Hours", "Logged Hours", "Billability", "Task Status", "Timesheet Status"]);
            modifiedArray.push(["", "Total Hours", this._tus.trimTimestamp(this._tus.minutesToTimestamp(totalEstimatedTime)), this._tus.trimTimestamp(this._tus.minutesToTimestamp(totaltrackedTime))]);

            const ws: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            xlsx.utils.sheet_add_aoa(ws, [[" Employee Timesheet Report"]], { origin: "A1" });
            xlsx.utils.sheet_add_aoa(ws, [["Employee Name", timesheets[0].employeeName]], { origin: "A2" });
            xlsx.utils.sheet_add_aoa(ws, [["Employee Email", timesheets[0].emailAddress]], { origin: "A3" });
            xlsx.utils.sheet_add_aoa(ws, [["Project Name", timesheets[0].projectName]], { origin: "A4" });
            xlsx.utils.sheet_add_aoa(ws, [["Timesheet Frequency", timesheetFrequencyText]], { origin: "A5" });
            xlsx.utils.sheet_add_aoa(ws, [["Type of Export", "Employee Wise"]], { origin: "A6" });

            xlsx.utils.sheet_add_aoa(ws, modifiedArray, { origin: "A9" });
            return { worksheet: ws, summary: summaryForUser };
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to get timesheet report in json array format
    async getTimesheetReportJsonArray(
        datesArray: Date[],
        projectId: number,
        timesheet: EmployeeWiseSummaryDto,
        timesheetFreq: ProjectTimesheetFrequencyEnum
    ): Promise<TimesheetEmployeeReportJson[]> {
        try {
            this._monitorService.logTrace("UI-getTimesheetReportJsonArray", { "getTimesheetReportJsonArray ": "getTimesheetReportJsonArray:action " + this + this.msg + this.dateTime })

            let timesheetJsonArray: TimesheetEmployeeReportJson[] = [];

            for (let i = 0; i < datesArray.length; i++) {
                let dateInWeek = datesArray[i];
                let daysInWeek = this._tus.getWeekDateArrayFromWeekRange(this._tus.getWeekRangeFromDate(dateInWeek));
                let dateRange;
                if (timesheetFreq === ProjectTimesheetFrequencyEnum.BiMonthly || timesheetFreq === ProjectTimesheetFrequencyEnum.Monthly) {
                    dateRange = this._tus.getTimesheetRangeFromFrequency(
                        datesArray[i],
                        timesheetFreq,
                        undefined
                    );
                }
                let individualTimesheet = timesheet.employeeWiseTaskDetailList;

                for (let i = 0; i < individualTimesheet.length; i++) {
                    let oneTaskRow = individualTimesheet[i];
                    let timesheetJsonObj = new TimesheetEmployeeReportJson();
                    timesheetJsonObj.hoursSpent = this.getStringInHourAndMinutes(oneTaskRow.trackedHours.toString());
                    timesheetJsonObj.dateString = moment(new Date(oneTaskRow.timesheetDate)).format("DD-MMM-YYYY");
                    timesheetJsonObj.taskName = oneTaskRow.taskName;
                    timesheetJsonObj.EstimatedHours = this.getHourAndMinutes(oneTaskRow.estimatedHours);
                    timesheetJsonObj.Billability = oneTaskRow.taskBillability == 1 ? "Billable" : "Non-Billable";
                    timesheetJsonObj.timesheetStatus = oneTaskRow.timesheetStatus;
                    if (oneTaskRow.status == "New") {
                        timesheetJsonObj.status = "New";
                    }
                    else if (oneTaskRow.status == "InProgress") {
                        timesheetJsonObj.status = "InProgress";
                    }
                    else if (oneTaskRow.status == "Overdue") {
                        timesheetJsonObj.status = "Overdue";
                    }
                    else {
                        timesheetJsonObj.status = "Completed";
                    }

                    timesheetJsonArray.push(timesheetJsonObj);
                }
            }

            return timesheetJsonArray;
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to create excel for daily timesheet report
    async exportToExcelDailyTimesheetReport(timesheets: TimeSheetDto[], projectId: number, projectName: string, reportName?: string) {

        // get the submission frequency for the project
        let submissionFrequency = await (await this.getTimesheetStats(projectId, timesheets[0].userId).toPromise()).submissionFrequency;

        // Find uique user ids in all the timesheets
        let usersInTimesheet = _.uniqBy(timesheets, (x) => x.userId).map((r) => r.userId);
        let userWiseTimesheeet: TimeSheetDto[][] = [];
        // iterate through the unique user ids and create 2d array with each item as an array of timesheets for the user
        for (let i = 0; i < usersInTimesheet.length; i++) {
            let timesheetsForUser = timesheets.filter((r) => r.userId === usersInTimesheet[i]);
            userWiseTimesheeet.push(timesheetsForUser);
        }

        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();

        // Find unique dates in all the timesheets
        let datesInTimesheet = _.uniqBy(timesheets, (r) => r.fromDate.toJSDate().getTime() && r.toDate.toJSDate().getTime());
        let dateWiseTimesheeet: TimeSheetDto[][] = [];
        // iterate through the unique dates and create 2d array with each item as an array of timesheets for the date
        for (let i = 0; i < datesInTimesheet.length; i++) {
            let timesheetsForDate = timesheets.filter((r) =>
                r.fromDate.toJSDate().getTime() === datesInTimesheet[i].fromDate.toJSDate().getTime() &&
                r.toDate.toJSDate().getTime() === datesInTimesheet[i].toDate.toJSDate().getTime());
            dateWiseTimesheeet.push(timesheetsForDate);
        }

        // iterate through the 2d array and generate a workbook for every user
        // all timesheets for the user will be clubbed into a single worksheet
        let userSummaryArray: SummaryTimesheetForUser[] = [];


        // iterate through the 2d array and generate a workbook for every date
        // all timesheets for a date will be clubbed into a single worksheet

        for (let i = 0; i < dateWiseTimesheeet.length; i++) {
            userSummaryArray = [];
            let summaryws: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            for (let j = 0; j < userWiseTimesheeet.length; j++) {
                let data = await this.getDatewiseSummary(dateWiseTimesheeet[i], userWiseTimesheeet[j], submissionFrequency, projectId);
                if (data.summary.member != null || data.summary.member != undefined) {
                    userSummaryArray.push(data.summary);
                }
            }
            this.createDailyTimesheetReportSummaryWorksheet(summaryws, dateWiseTimesheeet[i], userSummaryArray);
            xlsx.utils.book_append_sheet(wb, summaryws, this._tus.getTimesheetFromToDateString(dateWiseTimesheeet[i][0].fromDate, dateWiseTimesheeet[i][0].toDate));
        }

        // export excel
        if (reportName?.length > 0) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, `${_.capitalize(timesheets[0].projectName)} (Daily Timesheet Report).xlsx`);
        }
    }

 //   getDateFormatExport() {
 //       let dateFormat = "dd/MM/yyyy"; // Default date format
 //       if (AppConsts.dateFormatId) {
 //           const selectedDateFormat = AppConsts.dateFormatList.find((r) => r.id === AppConsts.dateFormatId);
 //           if (selectedDateFormat) {
 //               dateFormat = selectedDateFormat.name;
 //           }
 //       }
 //       return dateFormat;
 //   }
	
	//formatDateString(dateString, dateFormat) {
      
 //       let formattedDate = new Date(dateString).toLocaleDateString(undefined, {
 //           year: 'numeric',
 //           month: '2-digit',
 //           day: '2-digit',
 //       })

 //       if (dateFormat === "DD/MM/YYYY") {
 //           formattedDate = formattedDate.replace(/\//g, "-");
 //       } else if (dateFormat === "MM/DD/YYYY") {
 //           // Modify the format as needed
 //       } else if (dateFormat === "YYYY/DD/MM") {
 //           // Modify the format as needed
 //       }
    
 //       return formattedDate;
 //   }



    formatDateStringv2(dateString, dateFormat) {

        var timestamp = Date.parse(dateString);
        if (!isNaN(timestamp)) {
            let formattedDate = new Date(dateString);
            var formattedDate2: string
            if (dateFormat === "DD/MM/YYYY") {
                formattedDate2 = this.datepipe.transform(formattedDate, "dd/MM/yyyy");
                formattedDate2 = formattedDate2.replace(/\//g, "-");
            } else if (dateFormat === "MM/DD/YYYY") {
                formattedDate2 = this.datepipe.transform(formattedDate, "MM/dd/yyyy");
                formattedDate2 = formattedDate2.replace(/\//g, "-");
            } else if (dateFormat === "YYYY/DD/MM") {
                formattedDate2 = this.datepipe.transform(formattedDate, "yyyy/dd/MM");
                formattedDate2 = formattedDate2.replace(/\//g, "-");
            }
          
        }  
        return formattedDate2;
    }
    //Method to create excel based to summary timesheet report
    async exportToExcelOverallSummaryTimesheetReport(timesheetDetails: OverAllSummaryDto[], reportName: string) {
        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();
        let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

        xlsx.utils.sheet_add_aoa(overallSummary, [["Overall Summary Timesheet Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Project Name","Employee Id","Employee Name","Week Number", "Project Role", "Timesheet Date",  "Logged Hours", "Billed Hours", "Non-Billed Hours","Timesheet Status"]], {
            origin: "A2",
        });

        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
            x.push(r.projectName);
            x.push(r.employeeId);
            x.push(r.employeeName);
            x.push(moment(new Date(r.timesheetDate)).isoWeek());
            x.push(r.projectRole);
            x.push(new Date(r.timesheetDate));


            //let billedHrsString = this.getHourAndMinutes(r.billedHours);
            //x.push(this.getFormattedHoursAbove24Hrs(billedHrsString));

            x.push(Number(r.loggedHours.toFixed(2)));
            x.push(Number(r.billedHours.toFixed(2)));
            let nonBilledHours = Number(r.loggedHours.toFixed(2)) - Number(r.billedHours.toFixed(2));
            x.push(Number(nonBilledHours.toFixed(2)));

            x.push(r.timesheetStatus);
            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A3",
        });

           // Merge and center cells A1 to F1
           overallSummary["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8} }];
        this.styleTimesheetOverallSummarySheet(overallSummary);

        for (var i in overallSummary) {
            if (typeof overallSummary[i] != 'object') continue;
            let cell = xlsx.utils.decode_cell(i);
            if (cell.c == 8 || cell.c == 7|| cell.c == 6) {
                overallSummary[i].z = '0.00';
            }
            if (cell.c == 5) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
            if (cell.r == 0) {
                overallSummary[i].s.font.bold = true;
                overallSummary[i].s.font.underline = true; 
                overallSummary[i].s.font.sz = 12;
                overallSummary[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "FFFFFF" },

                };
                overallSummary[i].s.alignment = {
                    vertical: "center",
                        horizontal: "center",
                        wrapText: '1',
                }
            }
             // Check if the cell is A2
    if (cell.r ==1) { // A2 corresponds to row 1, column 0 (0-based index)
        overallSummary[i].s.font.bold = true; // Make it bold
        overallSummary[i].s.fill = {
      patternType: "solid",
      fgColor: { rgb: "DDDDDD" },
  };
      }
  
        }

        xlsx.utils.book_append_sheet(wb, overallSummary);

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Overall Summary Timesheet Report.xlsx");
        }
    }

    async exportToExcelOverallProductivityBarReport(productivityBarDetails: ProductivityBarReportDto[], reportName: string) {

        // initialize a new workbook

        const wb: xlsx.WorkBook = xlsx.utils.book_new();
        let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(overallSummary, [["Overall Summary Productivity Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Date","Employee ID","Name","Email", "User Roles",  "Group", "Interval", "Application", "Productivity", "Time"]], {

            origin: "A2",

        });

        // Date User ID Name    Email   User Roles  Group   Interval    Application Productivity    Time

        let modifiedSummaryArray = productivityBarDetails?.map((r) => {
            let x = [];
            
            var date = DateTime.local(new Date(r?.dateTime as any).getFullYear(),Number(new Date(r?.dateTime as any).getMonth() + 1),  
            Number(("0" + new Date(r?.dateTime as any).getDate()).slice(-2)) )



            x.push(date?.toJSDate());
            x.push(r?.employeeId);
            x.push(r?.name);
            x.push(r?.email);
            x.push(r?.roles);
            x.push(r?.group);
            x.push(r?.interval);
            x.push(r?.application);
            x.push(r?.productivity);
            x.push(r?.time);
            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A3",
        });

        overallSummary["!cols"] = [{ width: 15 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 25 }, { width: 20 }, { width: 20 }, { width: 25 }, { width: 15 }, { width: 20 }];

        for (let i in overallSummary) {
            if (typeof overallSummary[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            overallSummary[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },

            };
         
            overallSummary["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 9 } }];
            if (cell.r == 1) {
                overallSummary[i].s.font.bold = true;
                overallSummary[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
            if (cell.r == 0) {
                overallSummary[i].s.font.bold = true;
                overallSummary[i].s.font.underline = true; 
                overallSummary[i].s.font.sz = 12;
                overallSummary[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "FFFFFF" },

                };
                overallSummary[i].s.alignment = {
                    vertical: "center",
                        horizontal: "center",
                        wrapText: '1',
                }
            }
            if (cell.c == 1) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
        }
        xlsx.utils.book_append_sheet(wb, overallSummary);

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Productivity Report .xlsx");
        }
    }

    async exportToExcelOverallSummaryTimesheetReportPDF(timesheetDetails: OverAllSummaryDto[], reportName: string, dateFormat = 'dd/MM/yyyy') {
        let columns = [["Project Name",  "Employee Id " ,"Employee Name", "Week Number", "Project Role","Timesheet Date",   "Logged Hours", "Billed Hours","Non-Billed Hours", "Timesheet Status"]];

        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
          
            x.push(r.projectName);
            x.push(r.employeeId);
            x.push(r.employeeName);
            x.push(moment(new Date(r.timesheetDate)).isoWeek());
            x.push(r.projectRole);
            x.push(this.datepipe.transform(r.timesheetDate, dateFormat));
          

            //let billedHrsString = this.getHourAndMinutes(r.billedHours);
            //x.push(this.getFormattedHoursAbove24Hrs(billedHrsString));

            x.push(Number(r.loggedHours.toFixed(2)));
            x.push(Number(r.billedHours.toFixed(2)));
            let nonBilledHours = Number(r.loggedHours.toFixed(2)) - Number(r.billedHours.toFixed(2));
            x.push(Number(nonBilledHours.toFixed(2)));
            x.push(r.timesheetStatus);
            return x;
        });
        const doc = new jsPDF("l", "pt");
        doc.setFontSize(18);
        doc.text('Overall Summary Timesheet Report', 19, 30);
        doc.setFontSize(11);
        doc.setTextColor(100);
        (doc as any).autoTable({
            head: columns,
            body: modifiedSummaryArray,
            theme: 'striped',
            tableLineColor: [189, 195, 199],
            startY: 40,
            margin: {
                top: 20
            },
            columnStyles: {
                0: { cellWidth: 155 },
                1: { cellWidth: 100 },
            },
        });
        if (reportName != null || reportName != undefined) {
            doc.save(`${_.capitalize(reportName)}.pdf`);
        }
        else {
            doc.save("Overall Summary Timesheet Report.pdf");
        }
    }

    //Method to create task wise timesheet report
    async exportToExcelTaskWiseTimesheetReport(timesheetDetails: OverAllSummaryDto[], reportName: string) {
        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();

        let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

        xlsx.utils.sheet_add_aoa(overallSummary, [["Task Wise Timesheet Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Project Name","Employee Id", "Employee Name", "Week Number", "Project Role", "Timesheet Date","Task Job", "Tasks", "Estimated Hours", "Logged Hours", "Billed Hours", "Billability", "Billability Change Reason","Timesheet Status", "Task Status", "Comment"]], {
            origin: "A2",
        });

        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
            let taskStatus: string;
            let billabilityStatus: string;

            if (r.status == "New") {
                /*taskStatus = "Approved";*/
                taskStatus = "New";
            }
            else if (r.status == "InProgress") {
                /*taskStatus = "Pending";*/
                taskStatus = "In-Progress";
            }
            else if (r.status == "Overdue") {
                /* taskStatus = "Rejected";*/
                taskStatus = "Overdue";
            }
            else if (r.status == "Complete") {
                /* taskStatus = "Overdue";*/
                taskStatus = "Complete";
            }
            else if (r.status == "No Task Assign") {
                taskStatus = "No Task Assign";
            }

            if (r.taskBillability == 1) {
                billabilityStatus = "Billable";
            }
            else if (r.taskBillability == 2) {
                billabilityStatus = "Non-Billable";
            }
          
            x.push(r.projectName);
            x.push(r.employeeId);
            x.push(r.employeeName);
            x.push(moment(new Date(r.timesheetDate)).isoWeek());
            x.push(r.projectRole);
            x.push(new Date(r.timesheetDate));
            x.push(r.taskJobName);
            x.push(r.taskName);
            let estimateHours = this.getStringInHourAndMinutes(r.estimateHours);
            x.push(this.getFormattedHours(estimateHours));
            
            // getFormattedHours
            //let loggedHours = this.getHourAndMinutes(r.loggedHours);
           // x.push(this.getFormattedHours(loggedHours));
           // let billedHours = this.getHourAndMinutes(r.billedHours);
           // x.push(this.getFormattedHours(billedHours));

            x.push(Number(r.loggedHours.toFixed(2)));
            x.push(Number(r.billedHours.toFixed(2)));

            x.push(billabilityStatus);
            x.push(r.taskNonBillabityReason);
            x.push(r.timesheetStatus);
            x.push(taskStatus);
            x.push(r.comment);
            return x;
        });


        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A3",
        });
           // Merge and center cells A1 to F1
           overallSummary["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 14 } }];
        //  overallSummary[7].s.numFmt = "[h]:mm";
        this.styleExvele(overallSummary);
        for (var i in overallSummary) {
            if (typeof overallSummary[i] != 'object') continue;
            let cell = xlsx.utils.decode_cell(i);
            if (cell.c == 9 || cell.c == 10 || cell.c == 8) {
                overallSummary[i].z = '0.00';
            }
            if (cell.c == 4) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
            if (cell.r == 0) {
                overallSummary[i].s.font.bold = true;
                overallSummary[i].s.font.underline = true; 
                overallSummary[i].s.font.sz = 12;
                overallSummary[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "FFFFFF" },

                };
                overallSummary[i].s.alignment = {
                    vertical: "center",
                        horizontal: "center",
                        wrapText: '1',
                }
            }
             if (cell.c === 15) {
                overallSummary[i].s.alignment = {
                    vertical: "center",
                    horizontal: "left", 
                    wrapText: '1', // Enable text wrapping

                };

            }
        }
        xlsx.utils.book_append_sheet(wb, overallSummary);

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, " Task Wise Timesheet Report.xlsx");
        }
    }
    styleExvele(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 },{ width: 20 },{ width: 20 }, { width: 20 },{ width: 30 } ,{ width: 60 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 30 },{ width: 20 },{ width: 40 } , {width : 40}];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (cell.r == 1) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
           
            // }
            // if (cell.r > 0 && cell.c == 6) {
            //     ws[i].t = "n";
            //     ws[i].s.numFmt = "[h]:mm";
            // }
        }
    }
    async exportToExcelTaskWiseTimesheetReportPDF(timesheetDetails: OverAllSummaryDto[],    reportName: string, dateFormat = 'dd/MM/yyyy') {
        // initialize a new workbook
        let columns = [["Project Name", "Employee Id", "Employee Name","Week Number","Project Role",  "Timesheet Date", "Tasks", "Estimated Hours", "Logged Hours", "Billed Hours", "Billability", "Timesheet Status", "Task Status", "Comment"]];

        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
            let taskStatus: string;
            let billabilityStatus: string;

            if (r.status == "New") { /*taskStatus = "Approved";*/
                taskStatus = "New";
            }
            else if (r.status == "InProgress") { /*taskStatus = "Pending";*/
                taskStatus = "In-Progress";
            }
            else if (r.status == "Overdue") { /* taskStatus = "Rejected";*/
                taskStatus = "Overdue";
            }
            else if (r.status == "Complete") { /* taskStatus = "Overdue";*/
                taskStatus = "Complete";
            }
            else if (r.status == "No Task Assign") {
                taskStatus = "No Task Assign";
            }
            if (r.taskBillability == 1) {
                billabilityStatus = "Billable";
            }
            else if (r.taskBillability == 2) {
                billabilityStatus = "Non-Billable";
            }
           
            x.push(r.projectName);
            x.push(r.employeeId);
            // x.push(r.emailAddress);
            x.push(r.employeeName);
            x.push(moment(new Date(r.timesheetDate)).isoWeek());
            x.push(r.projectRole);
            x.push(this.datepipe.transform(new Date(r.timesheetDate), dateFormat));
            x.push(r.taskName);
            // let estimateHours = this.getStringInHourAndMinutes(r.estimateHours);
            x.push(this.getStringInHourAndMinutes(r.estimateHours) + ' h');

            x.push(this.getHourAndMinutes(r.loggedHours) + ' h');
            x.push(this.getHourAndMinutes(r.billedHours) + ' h');

            x.push(billabilityStatus);
            x.push(r.timesheetStatus);
            x.push(taskStatus);
            x.push(r.comment);
            return x;
        });
        const doc = new jsPDF("l", "pt");
        doc.setFontSize(18);
        doc.text('Task Wise Timesheet Report', 19, 30);
        doc.setFontSize(11);
        doc.setTextColor(100);
        (doc as any).autoTable({
            head: columns,
            body: modifiedSummaryArray,
            theme: 'striped',
            tableLineColor: [189, 195, 199],
            startY: 40,

            margin: {
                top: 20
            },
            columnStyles: {
                0: { cellWidth: 85 },
                1: { cellWidth: 45 },
                2: { cellWidth: 45 },
                3: { cellWidth: 45 },
                4: { cellWidth: 60 },
                5: { cellWidth: 50 },
                6: { cellWidth: 50 },
                7: { cellWidth: 60 },
                8: { cellWidth: 50 },
                9: { cellWidth: 50 },
                10: { cellWidth: 70 },
                11: { cellWidth: 50 },
                12: { cellWidth: 50 },
                13: { cellWidth: 80 }
            },
        });

        // export excel
        if (reportName != null || reportName != undefined) {
            doc.save(`${_.capitalize(reportName)}.pdf`);
        }
        else {
            doc.save("Task Wise Timesheet Report.pdf");
        }
    }

    // Overall Attendance report - Start
    async exportToExcelOverallSummaryAttendanceReport(timesheetDetails: OverAllSummaryRootDto, reportName: string) {
        // initialize a new workbook
       var date = timesheetDetails?.attendanceReportOverAllSummaryDto?.attendanceDuration?.split("-")
        const wb: xlsx.WorkBook = xlsx.utils.book_new();
         let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

        

        timesheetDetails.attendanceReportOverAllSummaryDto.months.forEach((month) => {
            let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            this.createOverallAttendanceSheet(overallAttendance, timesheetDetails.attendanceReportOverAllSummaryDto, month);
            xlsx.utils.book_append_sheet(wb, overallAttendance, month);
            this.styleOverallAttendanceSheet(overallAttendance);
        });

        this.createOverallAttendanceSummary(overallSummary, timesheetDetails.overAllSummarySheetReport);
 //this.createEmployeeWorkingStatusReport(overallSummary, timesheetDetails)

        xlsx.utils.book_append_sheet(wb, overallSummary, "Summary");

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, " Overall Summary Attendance Report.xlsx");
        }
    }
    

    async exportToExcelEmployeeWorkingstatusReport(UserWorkingList: WorkStatusUser[], reportName: string) {
      
        const wb: xlsx.WorkBook = xlsx.utils.book_new();
         let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

         UserWorkingList[0].months.forEach((month) => {
            let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            this.createEmployeeWorkingStatusReport(overallAttendance, UserWorkingList, month);
            xlsx.utils.book_append_sheet(wb, overallAttendance, month);
        });
        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Working Status Attendance Report.xlsx");
        }
    }

    
    //Method to create attendance excel report
    createOverallAttendanceSheet(overallAttendance: xlsx.WorkSheet, overAllSummarySheetReport: AttendanceReportOverAllSummaryDto, month: string) {

        xlsx.utils.sheet_add_aoa(overallAttendance, [["Overall Summary Attendance Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["Attendance Duration", overAllSummarySheetReport.attendanceDuration]], { origin: "A4" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["Export Type", overAllSummarySheetReport.exportType]], { origin: "A5" });

        xlsx.utils.sheet_add_aoa(overallAttendance, [["P", "Present"]], { origin: "G3" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["A", "Full day Absent/ Leave"]], { origin: "G4" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["1/2", "Half day Absent/ Leave"]], { origin: "G5" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["W", "Weekend"]], { origin: "G6" });
        xlsx.utils.sheet_add_aoa(overallAttendance, [["H", "Holiday"]], { origin: "G7" });
        var abcs = ["Employee Id", "Employee Name"];
        overAllSummarySheetReport.attendanceReportOverAllSummaryList[0].dayList.forEach((day, index) => {
            if (day.day.substring(0, 3) === month) {
                abcs.push(day.day);
            }
        });
        xlsx.utils.sheet_add_aoa(overallAttendance, [abcs], {
            origin: "A10",
        });

        let modifiedSummaryArray = overAllSummarySheetReport.attendanceReportOverAllSummaryList.map((r) => {
            let x = [];
            x.push(r.employeeId);
            x.push(r.employeeName);
            r.dayList.forEach((y) => {
                x.push(y)
            });
            return x;
        });

        let finalmodifiedSummaryArray = [];
        modifiedSummaryArray.forEach(userWIse => {
            let xyz = []
            
            userWIse = userWIse.filter((x, i) => {
                if (i > 1) {
                    if (x.status.status == "Un" || x.status.status == "U" ) x.status.status = "A";
                    if (x.status.status == "Hu") x.status.status = "1/2";
                    x.status.dateTime = DateTime.local(new Date(x.status.dateTime).getFullYear(),Number(new Date(x.status.dateTime).getMonth() + 1),  
                    Number(("0" + new Date(x.status.dateTime).getDate()).slice(-2)) )
                    if (x.status.dateTime.toFormat("MMM") === month) {
                        //x = x.status.status;
                        xyz.push(x.status.status)
                        return x;
                    }
                } else {
                    xyz.push(x);
                }
            });
            finalmodifiedSummaryArray.push(xyz);

        });
        modifiedSummaryArray = finalmodifiedSummaryArray

        xlsx.utils.sheet_add_aoa(overallAttendance, modifiedSummaryArray, {
            origin: "A11",
        });
        this.styleOverallAttendanceSheet(overallAttendance);
    }


    getDateTimeFromJSDate(date: Date) {
        let year = date.getFullYear();
        let month = Number(date.getMonth() + 1);
        let day = Number(("0" + date.getDate()).slice(-2));
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let second = date.getSeconds();
        return DateTime.local(year, month, day, hours, minutes, second);
        // this.weekRange[0].getFullYear(), Number(("0" + (this.weekRange[0].getMonth() + 1)).slice(-2)), Number(("0" + this.weekRange[0].getDate()).slice(-2))
    }
  
    col =[{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];

    createEmployeeWorkingStatusReport(overallSummary: xlsx.WorkSheet, overAllSummarySheetReport: WorkStatusUser[],month:string) {
     
        xlsx.utils.sheet_add_aoa(overallSummary, [["Working Status Attendance Report"]], { origin: "A1" });

        var row1 = ["Employee Id", "Employee Name"];
        var row2 = ["", "", "Working type", "Sublocality"]

       var  merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 9 } }, { s: { r: 2, c: 0 }, e: { r: 4, c: 0 } }, { s: { r: 2, c: 1 }, e: { r: 4, c: 1 } },
        ]; 
        var col =[{ width: 20 }, { width: 20 }];
       
       var currentmonth =  overAllSummarySheetReport[0].days.filter((x)=> x.substring(0, 3) === month)
    for (var i = 0; i <=  currentmonth.length; i++) {
           var index = currentmonth.length === i ? i-1 : i
            if (currentmonth[index].substring(0, 3) === month) {
                if(currentmonth.length !== i) row1.push(currentmonth[index]);
                row1.push("");  
                if(i != 0){
                    merge.push({ s: { r: 2, c: 2*i }, e: { r: 3, c: 2*i+1 } })
                col.push({ width: 20 })
                    col.push({ width: 20 })
                    row2.push( "Working type", "Sublocality")
                }
            }
                        
            }
             row1.pop();
             row2.pop();
             row2.pop();
      
        xlsx.utils.sheet_add_aoa(overallSummary, [row1], {
            origin: "A3",
        });


            xlsx.utils.sheet_add_aoa(overallSummary, [row2], {
                origin: "A5",
            });

        let modifiedSummaryArray = overAllSummarySheetReport?.map((r) => {
            let x = [];
            x.push(r.employeeId);
            x.push(r.fullName);

            r.userstatus.map((rr)=>{
              var abc= this.getDateTimeFromJSDate(new Date(rr.date as any))
              if(abc.toFormat("MMM") === month){
                x.push(this.getworkingtype(rr.workingFrom));
                x.push(rr.sublocality);
            }
            })
            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A6",
        });
        this.employeeWorkingStatusReportStylesheet(overallSummary,merge,col);
    }
    getworkingtype(WorkingFromTypes: WorkFromType[]): string {
        let types: string[] = [];
        WorkingFromTypes.forEach((type) => {
            switch (type) {
                case WorkFromType.WorkFromHome:
                    types.push("WFH");
                    break;
                case WorkFromType.WorkFromOffice:
                    types.push("WFO");
                    break;
                case WorkFromType.WorkFromRemote:
                    types.push("WFR");
                    break;
                default:
                    types.push("NA");
            }
        });
        return types.join("/");
    }

employeeWorkingStatusReportStylesheet(ws: xlsx.WorkSheet,merge :any,col:any) {
        ws["!cols"] = col;
        ws["!rows"] = [{ hpt: 20 }];

        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 2 || cell.r == 4) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
            }

           
        }
       ws["!merges"] =  merge;
        return ws;
    }



    //Method to style overall attendance sheet report
    styleOverallAttendanceSheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 30 }, { width: 25 }];
        ws["!rows"] = [{ hpt: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 9) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if ((cell.r == 3 || cell.r == 4) && cell.c == 0) {
                ws[i].s = {
                    font: {
                        sz: 12,
                        bold: true,
                    },
                }
            }

            if (((cell.r == 4 || cell.r == 3) && (cell.c == 0 || cell.c == 1))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (((cell.r == 4 || cell.r == 3 || cell.r == 6 || cell.r == 5 || cell.r == 2) && (cell.c == 6 || cell.c == 7 || cell.c == 8 || cell.c == 9 || cell.c == 10))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
            }

            if (ws[i].v === "H") {
                ws[i].s = {
                   alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "94EFE3" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "W") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFF1CC" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "1/2") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FBD0E4" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "A") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFC7CE" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }
        }
        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 33 } }, { s: { r: 2, c: 7 }, e: { r: 2, c: 10 } }, { s: { r: 3, c: 7 }, e: { r: 3, c: 10 } }, { s: { r: 4, c: 7 }, e: { r: 4, c: 10 } }, { s: { r: 5, c: 7 }, e: { r: 5, c: 10 } }, { s: { r: 6, c: 7 }, e: { r: 6, c: 10 } }];
        ws["!merges"] = merge;

        return ws;
    }

    //Method to create overall attendance report summary.
    createOverallAttendanceSummary(overallSummary: xlsx.WorkSheet, overAllSummarySheetReport: OverAllSummarySheetReport) {
        xlsx.utils.sheet_add_aoa(overallSummary, [["Overall Summary Attendance Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Attendance Duration", overAllSummarySheetReport.attendanceDuration]], { origin: "A3" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Export Type", "Overall Summary"]], { origin: "A4" });

        xlsx.utils.sheet_add_aoa(overallSummary, [["Email Id", "Employee Name", "Expected Payable days", "Worked Days", "Paid Leaves", "Unpaid Leaves", "Holiday", "Unknown", "Total Payable days"]], {
            origin: "A6",
        });

        let modifiedSummaryArray = overAllSummarySheetReport.employeeDetails.map((r) => {
            let x = [];
            x.push(r.employeeEmailAddress);
            x.push(r.employeeName);
            x.push(r.expectedPayabledays);
            x.push(r.workedDays_BusinessTrip_Coference);
            x.push(r.paidLeaves);
            x.push(r.unPaidLeaves);
            x.push(r.holiday);
            x.push(r.unknown);
            x.push(r.totalPayableDay);

            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A7",
        });
        this.styleOverallAttendanceSummarySheet(overallSummary);
    }

    //Method to apply style attendance summary excel report
    styleOverallAttendanceSummarySheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 30 }, { width: 25 }, { width: 20 }, { width: 20 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 20 }];
        ws["!rows"] = [{ hpt: 20 }, {}, {}, {}, {}, { hpt: 40 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (cell.r == 0 || ((cell.r == 2 || cell.r == 3) && cell.c == 0) || cell.r == 5) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if ((cell.r == 2 || cell.r == 3) && cell.c == 0) {
                ws[i].s = {
                    font: {
                        sz: 12,
                        bold: true,
                    },
                }
            }

            if ((cell.r == 2 || cell.r == 3) && (cell.c == 0 || cell.c == 1)) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }

                if (ws[i].v === "Summary Sheet") {
                    ws[i].s.font.bold = true;
                    ws[i].s.font.underline = true;
                    ws[i].s.fill = {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    };
                }
            }
        }
        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }];
        ws["!merges"] = merge;

        return ws;
    }
    // Overall Attendance report - End


    // Employee-wise Attendance report - Start
    exportToExcelEmployeeAttendanceReport(attendanceReport: AttendanceReportEmployeeWiseDto[], reportName: string) {
        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();

        attendanceReport.forEach((x) => {
            let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            this.createEmployeeAttendanceReport(x, overallAttendance);
            for (var i in overallAttendance) {
                if (typeof overallAttendance[i] != 'object') continue;
                let cell = xlsx.utils.decode_cell(i);
                if (cell.r > 11 && cell.c == 8 || cell.c == 5 || cell.c == 6 || cell.c == 7) {
                    overallAttendance[i].z = '0.00';
                }
                if (cell.r > 11 && cell.c == 0) {
                    overallAttendance[i].z = 'dd-mmm-yyyy';
                }
            }
            this.styleEmployeeAttendanceSheet(overallAttendance);
            let empName = x.employeeName.substring(0, 31);
            xlsx.utils.book_append_sheet(wb, overallAttendance, `${_.capitalize(x.employeeName.substring(0, 31))}`);
        });

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Team Member Wise Attendance Report.xlsx");
        }
    }

    //Method to create employee attendance report
    createEmployeeAttendanceReport(employeeData: AttendanceReportEmployeeWiseDto, workSheet: xlsx.WorkSheet) {
        try {
            xlsx.utils.sheet_add_aoa(workSheet, [["Team Member Wise Attendance Report"]], { origin: "A1" });

            xlsx.utils.sheet_add_aoa(workSheet, [["Employee Name", employeeData.employeeName]], { origin: "A3" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Employee Id", employeeData.employeeId]], { origin: "A4" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Duration", employeeData.duration]], { origin: "A5" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Report Type", employeeData.reportType]], { origin: "A6" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Type of Export", employeeData.typeOfExport]], { origin: "A7" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Working Hours", employeeData.workingHourse]], { origin: "A8" });

            xlsx.utils.sheet_add_aoa(workSheet, [["Present", employeeData.present]], { origin: "E4" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Absent", employeeData.absent]], { origin: "E5" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Holiday", employeeData.holiday]], { origin: "E6" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Weekend", employeeData.weekend]], { origin: "E7" });

            xlsx.utils.sheet_add_aoa(workSheet, [["Date", "Clock In", "", "Clock Out", "","Productive Time","Unproductive Time","Neutral Time", "Total Time at work", "Required hours", "Overtime/Undertime", "Total Active Time", "Productivity", "Effectiveness", "Status"]], {
                origin: "A12",
            });

            xlsx.utils.sheet_add_aoa(workSheet, [["", "Arrival Time", "Early/Late", "Left Time", "Early/Late"]], {
                origin: "A13",
            });

            let modifiedSummaryArray = employeeData.attendanceDetails.map((r) => {
                let x = [];
                // x.push(this._tus.getWeekStringArray(r.reportDate.toJSDate(), "DD MMMM YYYY")[0]);
                x.push(new Date(r.reportDate as any));
                x.push(r.clock_In_ArrivalTime ? r.clock_In_ArrivalTime : "-");
                x.push(r.clock_In_Early_Late ? this.getEarlyLateArrivalTimeFormat(r.clock_In_Early_Late) : "-");
                x.push(r.clock_Out_Left_Time ? r.clock_Out_Left_Time : "-");
                x.push(r.clock_Out_Early_Late ? this.getEarlyLateLeftTimeFormat(r.clock_Out_Early_Late) : "-");
                x.push(r.productiveTime ? r.productiveTime: "-");
                x.push(r.unProductiveTime ? r.unProductiveTime: "-");
                x.push(r.nuetralTime ?r.nuetralTime  : "-");
                x.push(r.totalTimeAtWork ? Number(r.totalTimeAtWork) : 0);
                x.push(r.requiredHourse ? this.getFormattedHoursAbove24Hrs(r.requiredHourse) : 0);
                x.push(r.overTime_UnderTime ? this.getFormattedHoursAbove24Hrs(r.overTime_UnderTime) : 0);
                x.push(r.total_Active_Time ? Number(r.total_Active_Time) : 0);
                x.push(r.productivity);
                x.push(r.effectiveness);
                x.push(r.status);

                return x;
            });
            xlsx.utils.sheet_add_aoa(workSheet, modifiedSummaryArray, {
                origin: "A14",
            });

            return { workSheet };
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to get early arrival time format
    getEarlyLateArrivalTimeFormat(timespan: string) {
        let timeFrame = timespan.split(":");
        let hr = parseInt(timeFrame[0]);
        let min = parseInt(timeFrame[1]);

        if ((hr <= 0) && (min < 0)) {
            return `+${Math.abs(hr) < 10 ? "0" + Math.abs(hr) : Math.abs(hr)}:${Math.abs(min) < 10 ? "0" + Math.abs(min) : Math.abs(min)}`;
        }
        else if ((hr == 0) && (min == 0)) {
            return `${Math.abs(hr) < 10 ? "0" + Math.abs(hr) : Math.abs(hr)}:${Math.abs(min) < 10 ? "0" + Math.abs(min) : Math.abs(min)}`;
        }
        else {
            return `-${hr < 10 ? "0" + hr : hr}:${min < 10 ? "0" + min : min}`;
        }
    }

    //Method to get early left time format
    getEarlyLateLeftTimeFormat(timespan: string) {
        let timeFrame = timespan.split(":");
        let hr = parseInt(timeFrame[0]);
        let min = parseInt(timeFrame[1]);

        if ((hr <= 0) && (min <= 0)) {
            return `-${Math.abs(hr) < 10 ? "0" + Math.abs(hr) : Math.abs(hr)}:${Math.abs(min) < 10 ? "0" + Math.abs(min) : Math.abs(min)}`;
        }
        else if ((hr == 0) && (min == 0)) {
            return `${Math.abs(hr) < 10 ? "0" + Math.abs(hr) : Math.abs(hr)}:${Math.abs(min) < 10 ? "0" + Math.abs(min) : Math.abs(min)}`;
        }
        else {
            return `+${hr < 10 ? "0" + hr : hr}:${Math.abs(min) < 10 ? "0" + Math.abs(min) : Math.abs(min)}`;
        }
    }

    getHoursAndMin(timespan: string) {
        if (!timespan) return '00:00';
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }

    //Method to apply style on employee attendance sheet report
    styleEmployeeAttendanceSheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 30 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },  { width: 20 }, { width: 20 }, { width: 20 },{ width: 20 }];
        ws["!rows"] = [{ hpt: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 11 || cell.r == 12) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (((cell.r == 2 || cell.r == 3 || cell.r == 4 || cell.r == 5 || cell.r == 6 || cell.r == 7) && (cell.c == 0))) {
                ws[i].s = {
                    font: {
                        sz: 12,
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (((cell.r == 2 || cell.r == 3 || cell.r == 4 || cell.r == 5 || cell.r == 6 || cell.r == 7) && cell.c == 1)) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (((cell.r == 4 || cell.r == 3 || cell.r == 6 || cell.r == 5) && (cell.c == 4 || cell.c == 5))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
            }


            if (ws[i].v === "Present") {
                ws[i].s = {
                    font: {
                        underline: true,
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "00B050" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Absent") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FF66FF" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Holiday") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "00B0F0" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Weekend") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFC000" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }
        }

        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 18 } }, { s: { r: 11, c: 0 }, e: { r: 12, c: 0 } }, { s: { r: 11, c: 1 }, e: { r: 11, c: 2 } },
        { s: { r: 11, c: 3 }, e: { r: 11, c: 4 } }, { s: { r: 11, c: 5 }, e: { r: 12, c: 5 } }, { s: { r: 11, c: 6 }, e: { r: 12, c: 6 } },
        { s: { r: 11, c: 7 }, e: { r: 12, c: 7 } }, { s: { r: 11, c: 8 }, e: { r: 12, c: 8 } }, { s: { r: 11, c: 9 }, e: { r: 12, c: 9 } },
        { s: { r: 11, c: 10 }, e: { r: 12, c: 10 } }, { s: { r: 11, c: 11 }, e: { r: 12, c: 11 } }    
    ];
        ws["!merges"] = merge;

        return ws;
    }
    // Employee-wise Attendance report - End


    // Date-wise Attendance report - Start
    //Method to generate date wise attendance report
    exportToExcelDateAttendanceReport(attendanceReport: AttendanceReportDto[], reportName: string) {
        try {
            // initialize a new workbook
            const wb: xlsx.WorkBook = xlsx.utils.book_new();

            // let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

            attendanceReport.forEach((x) => {
                let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
                this.createDatewiseAttendanceSheet(x, overallAttendance);
                for (var i in overallAttendance) {
                    if (typeof overallAttendance[i] != 'object') continue;
                    let cell = xlsx.utils.decode_cell(i);
                    if (cell.r > 11 && cell.c == 8 || cell.c == 9 || cell.c == 6 || cell.c == 7) {
                        overallAttendance[i].z = '0.00';
                    }
                }
                this.styleDatewiseAttendanceSheet(overallAttendance);
                xlsx.utils.book_append_sheet(wb, overallAttendance, `${_.capitalize(x.reportDate)}`);
            });

            // export excel
            if (reportName != null || reportName != undefined) {
                xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
            }
            else {
                xlsx.writeFile(wb, "Date Wise Attendance Report.xlsx");
            }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to generate date wise attendance sheet
    createDatewiseAttendanceSheet(employeeData: AttendanceReportDto, workSheet: xlsx.WorkSheet) {
        try {
            xlsx.utils.sheet_add_aoa(workSheet, [["Date Wise Attendance Report"]], { origin: "A1" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Date", employeeData.reportDate, ""]], { origin: "A5" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Report Type", employeeData.reportType, ""]], { origin: "A6" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Type of Export", "Date-wise Report", ""]], { origin: "A7" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Working Hours", employeeData.workingHours, ""]], { origin: "A8" });

            xlsx.utils.sheet_add_aoa(workSheet, [["Present", employeeData.present]], { origin: "E5" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Absent", employeeData.absent]], { origin: "E6" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Holiday", employeeData.holiday]], { origin: "E7" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Weekend", employeeData.weekEnd]], { origin: "E8" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Employee Id", "Employee Name", "Clock In", "", "Clock Out", "","Productive Time","Unproductive Time","Neutral Time", "Total Time at work", "Required hours", "Overtime/Undertime", "Total Active Time", "Productivity", "Effectiveness", "Status"]], {
                origin: "A12",
            });


            xlsx.utils.sheet_add_aoa(workSheet, [["", "", "Arrival Time", "Early/Late", "Left Time", "Early/Late", "", "", "", "", "", "", "", "", "", ""]], {
                origin: "A13",
            });

            let modifiedSummaryArray = employeeData.attendanceReportDetails.map((r) => {
                let x = [];
                x.push(r.employeeId ? r.employeeId : "-");
                x.push(r.employeeName ? r.employeeName : "-");
                x.push(r.arrivalTime ? r.arrivalTime : "-");
                x.push(r.arrival_Early_Late ? this.getEarlyLateArrivalTimeFormat(r.arrival_Early_Late) : "-");
                x.push(r.leftTime ? r.leftTime : "-");
                x.push(r.left_Early_Late ? this.getEarlyLateLeftTimeFormat(r.left_Early_Late) : "-");
                x.push(r.productiveTime ? r.productiveTime: "-");
                x.push(r.unProductiveTime ? r.unProductiveTime: "-");
                x.push(r.nuetralTime ?r.nuetralTime  : "-");
                x.push(r.totalTimeAtWork ? this.getFormattedHoursAbove24Hrs(r.totalTimeAtWork) : 0);
                x.push(r.requiredHourse ? this.getFormattedHoursAbove24Hrs(r.requiredHourse) : 0);
                x.push(r.overTime_UnderTime ? this.getFormattedHoursAbove24Hrs(r.overTime_UnderTime) : 0);
                x.push(r.totalActiveTime ? this.getFormattedHoursAbove24Hrs(r.totalActiveTime) : 0);
                x.push(r.productivity);
                x.push(r.effectiveness);
                x.push(r.status);

                return x;
            });
            xlsx.utils.sheet_add_aoa(workSheet, modifiedSummaryArray, {
                origin: "A14",
            });

            return { workSheet };
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to style date wise attendance report
    styleDatewiseAttendanceSheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 30 }, { width: 30 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
        ws["!rows"] = [{ hpt: 20 }];

        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 11 || cell.r == 12) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if ((cell.r == 4 || cell.r == 5 || cell.r == 6 || cell.r == 7) && cell.c == 0) {
                ws[i].s = {
                    font: {
                        sz: 12,
                        bold: true,
                    },
                }
            }

            if (((cell.r == 4 || cell.r == 5 || cell.r == 6 || cell.r == 7) && (cell.c == 0 || cell.c == 1))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (((cell.r == 4 || cell.r == 6 || cell.r == 5) && (cell.c == 4 || cell.c == 5))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
            }

            if (ws[i].v === "Present") {
                ws[i].s = {
                    font: {
                        underline: true,
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "00B050" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Absent") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FF66FF" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Holiday") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "00B0F0" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (ws[i].v === "Weekend") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFC000" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

        }
        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 15 } },
        { s: { r: 4, c: 1 }, e: { r: 4, c: 2 } }, { s: { r: 5, c: 1 }, e: { r: 5, c: 2 } }, { s: { r: 6, c: 1 }, e: { r: 6, c: 2 } },
        { s: { r: 7, c: 1 }, e: { r: 7, c: 2 } }, { s: { r: 11, c: 0 }, e: { r: 12, c: 0 } }, { s: { r: 11, c: 1 }, e: { r: 12, c: 1 } },
        { s: { r: 11, c: 2 }, e: { r: 11, c: 3 } }, { s: { r: 11, c: 4 }, e: { r: 11, c: 5 } }, { s: { r: 11, c: 6 }, e: { r: 12, c: 6 } },
        { s: { r: 11, c: 7 }, e: { r: 12, c: 7 } }, { s: { r: 11, c: 8 }, e: { r: 12, c: 8 } }, { s: { r: 11, c: 9 }, e: { r: 12, c: 9 } },
        { s: { r: 11, c: 10 }, e: { r: 12, c: 10 } }, { s: { r: 11, c: 11 }, e: { r: 12, c: 11 } }, { s: { r: 11, c: 12 }, e: { r: 12, c: 12 } },
        { s: { r: 11, c: 13 }, e: { r: 12, c: 13 } }, { s: { r: 11, c: 14 }, e: { r: 12, c: 14 } }, { s: { r: 11, c: 15 }, e: { r: 12, c: 15 } },];
        ws["!merges"] = merge;

        return ws;
    }
    // Date-wise Attendance report - End


    // Overall Time Off report - Start
    getTimeOffReport(timeOffData: TimeOffReportDto, reportName: string) {
        // initialize a new workbook
        try {
            const wb: xlsx.WorkBook = xlsx.utils.book_new();

            let overallTimeOffSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            let DetailedTimeOff: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

            this.createOverallTimeOffSummary(timeOffData, overallTimeOffSummary);
            this.createTimeOffDetailedReport(timeOffData, DetailedTimeOff);

            xlsx.utils.book_append_sheet(wb, overallTimeOffSummary, "Summary");
            xlsx.utils.book_append_sheet(wb, DetailedTimeOff, "Detailed");

            // export excel
            if (reportName != null || reportName != undefined) {
                xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
            }
            else {
                xlsx.writeFile(wb, "Leave Report.xlsx");
            }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    getTimeOffReportPDF(timeOffData: TimeOffReportDto, reportName: string) {

        let columns = [[ "Employee Id","Employee Name", /*"Employee Email",*/ "Sick", "Casual Leave", "Parental", "Vacation", "Half Day", "Total", "Available Balance", "Booked", "Unknown", "Total", /*"Conference", "Business", "Total"*/ "Overall"]];

        let modifiedSummaryArray = timeOffData.timeOffSummary.map((r) => {
            let x = [];
            x.push(r.employeeId);
            x.push(r.employeeName);
            // x.push(r.employeeEmail);
            x.push(r.paid_Leave_Sick);
            x.push(r.paid_Leave_RestDay);
         //   x.push(r.paid_Leave_Out_Off_Office);
            x.push(r.paid_Leave_Parental);
            x.push(r.paid_Leave_Vacation);
            x.push(r.paid_Leave_Half_Day);
            x.push(r.paid_Leave_Total);
            x.push(r.available_Balance);
            x.push(r.unPaidLeave_Booked);
            x.push(r.unPaidLeave_Unknown);
            x.push(r.unPaidLeave_Total);
            // x.push(r.awayTime_Conference);
            // x.push(r.awayTime_Business_trip);
            // x.push(r.awayTime_Total);
            x.push(r.overAll);

            return x;
        });
        const doc = new jsPDF("l", "pt");
        doc.setFontSize(18);
        doc.text('Leave  Report', 19, 30);
        doc.setFontSize(11);
        doc.setTextColor(100);
        (doc as any).autoTable({
            head: columns,
            body: modifiedSummaryArray,
            theme: 'striped',
            tableLineColor: [189, 195, 199],
            startY: 40,
            margin: {
                top: 20
            },
            // columnStyles: {
            //     0: { cellWidth: 155 },
            //     1: { cellWidth: 100 },
            // },
        });
        if (reportName != null || reportName != undefined) {
            doc.save(`${_.capitalize(reportName)}.pdf`);
        }
        else {
            doc.save("Leave  Report.pdf");
        }
    }


    //Method to create time off summary
    createOverallTimeOffSummary(timeOffData: TimeOffReportDto, overallTimeOffSummary: xlsx.WorkSheet) {
        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["Leave Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["Leave Duration", timeOffData.leaveDuration]], { origin: "A3" });
        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["Export Type", timeOffData.exportType]], { origin: "A4" });

        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["Employee Id","Employee Name",  "Paid Leave",  "", "", "", "", "", "", "Unpaid Leave","", "", "Overall"]], {
            origin: "A6",
        });

        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["", "", "Booked", "", "", "", "", "", "Available Balance", "Booked", "Unknown", "", ""]], {
            origin: "A7",
        });

        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, [["", "", "Sick", "Casual leave", "Parental", "Vacation", "Half Day", "Total", "", "", "", "Total", ""]], {
            origin: "A8",
        });

        let modifiedSummaryArray = timeOffData.timeOffSummary.map((r) => {
            let x = [];
            x.push(r.employeeId || ' ');
            x.push(r.employeeName);
            x.push(r.paid_Leave_Sick);
            x.push(r.paid_Leave_RestDay);
            // x.push(r.paid_Leave_Out_Off_Office);
            x.push(r.paid_Leave_Parental);
            x.push(r.paid_Leave_Vacation);
            x.push(r.paid_Leave_Half_Day);
            x.push(r.paid_Leave_Total);
            x.push(r.available_Balance);
            x.push(r.unPaidLeave_Booked);
            x.push(r.unPaidLeave_Unknown);
            x.push(r.unPaidLeave_Total);
            // x.push(r.awayTime_Conference);
            // x.push(r.awayTime_Business_trip);
            // x.push(r.awayTime_Total);
            x.push(r.overAll);

            return x;
        });
        xlsx.utils.sheet_add_aoa(overallTimeOffSummary, modifiedSummaryArray, {
            origin: "A9",
        });
        this.styleOverallTimeOffSummary(overallTimeOffSummary);
    }
    //Method to apply style on time off summary
    styleOverallTimeOffSummary(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 14.45 }, { width: 35.45 }, { width: 4.45 }, { width: 8.56 }, { width: 8.45 }, { width: 8.67 }, { width: 8.34 }, { width: 5.45 }, { width: 16.67 }, { width: 7.67 }, { width: 9.56 }, { width: 5.45 }, { width: 7.45 },/* { width: 20 }, { width: 20 }*/];
        ws["!rows"] = [{ hpt: 20 }];

        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 6 || cell.r == 7 || cell.r == 5) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if ((cell.r == 2 || cell.r == 3) && cell.c == 0) {
                ws[i].s = {
                    font: {
                        sz: 12,
                        bold: true,
                    },
                }
            }

            if (((cell.r == 2 || cell.r == 3) && (cell.c == 0 || cell.c == 1))) {
                ws[i].s = {
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
            }

            if (ws[i].v === "Weekend") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFC000" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }
        }
        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 12 } }, { s: { r: 5, c: 0 }, e: { r: 7, c: 0 } }, { s: { r: 5, c: 1 }, e: { r: 7, c: 1 } },
        { s: { r: 5, c: 2 }, e: { r: 5, c: 8 } }, { s: { r: 5, c: 9 }, e: { r: 5, c: 11 } }, { s: { r: 5, c: 12 }, e: { r: 7, c: 12 } },
        { s: { r: 6, c: 2 }, e: { r: 6, c: 7 } }];
        ws["!merges"] = merge;

        return ws;
    }

    createTimeOffDetailedReport(timeOffData: TimeOffReportDto, DetailedTimeOff: xlsx.WorkSheet) {
        try {

            // xlsx.utils.sheet_add_aoa(DetailedTimeOff, [["Leave Report"]], { origin: "A1" });

            xlsx.utils.sheet_add_aoa(DetailedTimeOff, [["Employee Id", "Employee Name", "Leave Type", "Leave Date","Submitted Date" ,"Project", "Days Taken", "Status", "Approved By", "Reason For Leave"]], {
                origin: "A1",
            });

        ;

            let modifiedSummaryArray = timeOffData.timeOffDetails.map((r) => {
                let x = [];

                x.push(r.employeeId ? r.employeeId : "-");
                x.push(r.employeeName ? r.employeeName : "-");

                // if (r.timeOffDetails?.length > 0) {
                //     r.timeOffDetails.forEach((z) => {
                let awayTimeType;
                let timeOffStatus;

                if (r.awayTimeTypeList == 1) {
                    awayTimeType = "Conference";
                }
                else if (r.awayTimeTypeList == 2) {
                    awayTimeType = "Parental Leave";
                }
                else if (r.awayTimeTypeList == 3) {
                    awayTimeType = "Business Trip";
                }
                else if (r.awayTimeTypeList == 4) {
                    awayTimeType = "Vacation";
                }
                else if (r.awayTimeTypeList == 5) {
                    awayTimeType = "Unpaid Leave";
                }
                else if (r.awayTimeTypeList == 6) {
                    awayTimeType = "Sick";
                }
                else if (r.awayTimeTypeList == 7) {
                    awayTimeType = "Casual Leave";
                }
                else if (r.awayTimeTypeList == 8) {
                    awayTimeType = "Out Of Office";
                }
                else if (r.awayTimeTypeList == 9) {
                    awayTimeType = "Public Holiday";
                }
                else if (r.awayTimeTypeList == 10) {
                    awayTimeType = "HalfDay";
                } else if (r.awayTimeTypeList == 11) {
                    awayTimeType = "Unknown";
                }

                if (r.status == 1) {
                    timeOffStatus = "Approved";
                }
                else if (r.status == 2) {
                    timeOffStatus = "Pending";
                }
                else if (r.status == 3) {
                    timeOffStatus = "Rejected";
                }
                else if (r.status == 4) {
                    timeOffStatus = "Overdue";
                } else if (r.status == 6) {
                    timeOffStatus = "NA";
                }
                else {
                    timeOffStatus = "System Approved";
                }

                x.push(awayTimeType ? awayTimeType : "-");
                x.push(r.leaveDate ? new Date(r.leaveDate as any) : "-");
                x.push(r.submittedDate ? new Date(r.submittedDate as any) : "-")
                x.push(r.project ? r.project : "-");
                x.push(r.day_Taken ? r.day_Taken : "-");
                x.push(timeOffStatus ? timeOffStatus : "-");
                x.push(r.approvedBy ? r.approvedBy : "-");
                x.push(r.reasonForLeave ? r.reasonForLeave : "-");

                return x;
            });
            xlsx.utils.sheet_add_aoa(DetailedTimeOff, modifiedSummaryArray, {
                origin: "A2",
            });
            this.styleTimeOffDetailedReport(DetailedTimeOff);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    styleTimeOffDetailedReport(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 12 }, { width: 26.34 }, { width: 11.89 }, { width: 10.67 },{ width: 15 },{width:44.45} ,{ width: 10.89 }, { width: 9.67 }, { width: 16.56 }, { width: 24.67 },/* { width: 25 }, { width: 25 }, { width: 20 }, { width: 20 }*/];
        ws["!rows"] = [{ hpt: 20 }]; //0.78

        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    // horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        // horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            // if (cell.r == 0) {
            //     ws[i].s = {
            //         font: {
            //             sz: 15,
            //             bold: true,
            //             underline: true
            //         },
            //         alignment: {
            //             vertical: "center",
            //             horizontal: "center",
            //             wrapText: '1', // any truthy value here
            //         },
            //         fill: {
            //             patternType: "solid",
            //             fgColor: { rgb: "DDDDDD" },
            //         }
            //     }
            // }

            if (ws[i].v === "Weekend") {
                ws[i].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "FFC000" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
            }
        }
        const merge = [/*{ s: { r: 0, c: 0 }, e: { r: 0, c: 9 } },*/ /*{ s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }, { s: { r: 2, c: 1 }, e: { r: 3, c: 1 } },
        { s: { r: 2, c: 2 }, e: { r: 3, c: 2 } },  { s: { r: 2, c: 5 }, e: { r: 3, c: 5 } },{ s: { r: 2, c: 3 }, e: { r: 3, c: 3 } },{ s: { r: 2, c: 4 }, e: { r: 3, c: 4 } },
        { s: { r: 2, c: 6 }, e: { r: 3, c: 6 } }, { s: { r: 2, c: 7 }, e: { r: 3, c: 7 } }, { s: { r: 2, c: 8 }, e: { r: 3, c: 8 } },
    { s: { r: 2, c: 9 }, e: { r: 3, c: 9 } }, { s: { r: 2, c: 10 }, e: { r: 3, c: 10 } }, { s: { r: 2, c: 11 }, e: { r: 3, c: 11 } },*/];
        ws["!merges"] = merge;

        return ws;
    }
    // Overall Time Off report - End

    //Method to get date wise summary details
    async getDatewiseSummary(dateTimesheets: TimeSheetDto[], userTimesheets: TimeSheetDto[],
        timesheetFrequency: ProjectTimesheetFrequencyEnum,
        projectId: number): Promise<{ summary: SummaryTimesheetForUser }> {
        try {
            this._monitorService.logTrace("UI-getDatewiseSummary", { "getDatewiseSummary ": "getDatewiseSummary:action " + this + this.msg + this.dateTime })
            let summaryForUser = new SummaryTimesheetForUser();
            for (let i = 0; i < userTimesheets.length; i++) {

                if (dateTimesheets[0].fromDate.toJSDate().getTime() === userTimesheets[i].fromDate.toJSDate().getTime()) {
                    let timesheetJsonArrayForOneUser: TimesheetJson[] = [];

                    let timesheet = userTimesheets[i];
                    let datesArray = this._tus.getDatesArrayFromFrequency(timesheet, timesheetFrequency);
                    let timesheetJsonArray = await this.getTimesheetJsonArray(datesArray, projectId, timesheet, timesheetFrequency);
                    timesheetJsonArrayForOneUser = [...timesheetJsonArrayForOneUser, ...timesheetJsonArray];

                    let modifiedArray = timesheetJsonArrayForOneUser.map((r) => {
                        let x = [];
                        x.push(r.dateString);
                        x.push(r.taskName);
                        x.push(r.EstimatedHours);
                        x.push(r.hoursSpent);
                        x.push(r.Billability);
                        x.push(r.status);
                        return x;
                    });

                    let totaltrackedTime = modifiedArray.reduce((a, v) => {
                        a += this._tus.timestampToMinutes(v[3]);
                        return a;
                    }, 0);


                    summaryForUser.member = timesheet.userName;
                    summaryForUser.role = timesheet.userRole;
                    summaryForUser.totalHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(totaltrackedTime));
                    summaryForUser.requiredHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheet.requiredHours)));
                    summaryForUser.BilledHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheet.billedHours)));
                    if (timesheet.timesheetStatus == 1) {
                        summaryForUser.TimeSheetStatus = "Approved";
                    }
                    else if (timesheet.timesheetStatus == 2) {
                        summaryForUser.TimeSheetStatus = "Pending";
                    }
                    else if (timesheet.timesheetStatus == 3) {
                        summaryForUser.TimeSheetStatus = "Rejected";
                    }
                    else if (timesheet.timesheetStatus == 4) {
                        summaryForUser.TimeSheetStatus = "Overdue";
                    }
                }
            }
            return { summary: summaryForUser };
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }


    //Method to return comment observable
    getCommentBarHideObs() {
        return this.commentBarHidden.asObservable();
    }

    //Method to create daily timesheet summary report excel 
    createDailyTimesheetReportSummaryWorksheet(summaryws: xlsx.WorkSheet, timesheets: TimeSheetDto[], summaryArray: SummaryTimesheetForUser[]) {

        let timesheetFrequency: any;
        if (timesheets[0].timesheetFrequency == 1) {
            timesheetFrequency = "BiMonthly";
        }
        else if (timesheets[0].timesheetFrequency == 2) {
            timesheetFrequency = "Monthly";
        }
        else if (timesheets[0].timesheetFrequency == 3) {
            timesheetFrequency = "Weekly";
        }
        else if (timesheets[0].timesheetFrequency == 4) {
            timesheetFrequency = "Daily";
        }
        xlsx.utils.sheet_add_aoa(summaryws, [["Summary Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(summaryws, [["Project Name", timesheets[0].projectName]], { origin: "A2" });
        xlsx.utils.sheet_add_aoa(summaryws, [["Timesheet Frequency", timesheetFrequency]], { origin: "A3" });
        xlsx.utils.sheet_add_aoa(summaryws, [["Timesheet Period", this.getTimesheetFromToDateString(timesheets[0].fromDate, timesheets[0].toDate)]], {
            origin: "A4",
        });
        xlsx.utils.sheet_add_aoa(summaryws, [["Member", "Role", "Required Hours", "Logged Hours", "Billed Hours", "Status"]], {
            origin: "A6",
        });
        let modifiedSummaryArray = summaryArray.map((r) => {
            let x = [];
            x.push(r.member);
            x.push(r.role);
            x.push(r.requiredHours);
            x.push(r.totalHours);
            x.push(r.BilledHours);
            x.push(r.TimeSheetStatus);

            return x;
        });
        xlsx.utils.sheet_add_aoa(summaryws, modifiedSummaryArray, {
            origin: "A7",
        });
        this.styleDailyTimesheetSummarySheet(summaryws);
    }

    //Method to style daily timesheet summary
    styleDailyTimesheetSummarySheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 30 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (((cell.r == 1 || cell.r == 2 || cell.r == 3) && cell.c == 0) || cell.r == 5) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }

            if (cell.r == 1 && cell.c == 1) {
                ws[i].s = {
                    font: {
                        sz: 14,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                }
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "D9E5F6" },
                };
            }
        }
    }

    //Method to style overall timesheet summary
    styleTimesheetOverallSummarySheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 30 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },{ width: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (cell.r == 0) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
    }

    //Method to get summary data
    getSummaryTabData(projectIds: number[], userIds: number[]): Observable<ProjectListViewSummaryDto[]> {
        return this._tsProxy.getProjectListForViewSummary(projectIds, userIds);
    }

    //Method to create summary sheet in excel
    createSummaryWorksheet(summaryws: xlsx.WorkSheet, timesheets: TimeSheetDto[], summaryArray: SummaryTimesheetForUser[]) {
        xlsx.utils.sheet_add_aoa(summaryws, [["Project Name", timesheets[0].projectName]], { origin: "A2" });
        xlsx.utils.sheet_add_aoa(summaryws, [["Timesheet Period", this.getTimesheetFromToDateString(timesheets[0].fromDate, timesheets[0].toDate)]], {
            origin: "A3",
        });
        xlsx.utils.sheet_add_aoa(summaryws, [["Member", "Role", "Required Hours", "Submitted Hours", "Billed Hours", "Status"]], {
            origin: "A5",
        });
        let modifiedSummaryArray = summaryArray.map((r) => {
            let x = [];
            x.push(r.member);
            x.push(r.role);
            x.push(r.requiredHours);
            x.push(r.totalHours);
            x.push(r.BilledHours);
            x.push(r.TimeSheetStatus);

            return x;
        });
        xlsx.utils.sheet_add_aoa(summaryws, modifiedSummaryArray, {
            origin: "A6",
        });
        this.styleSummarySheet(summaryws);
    }

    //Method to style summary sheet 
    styleSummarySheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (((cell.r == 1 || cell.r == 2) && cell.c == 0) || cell.r == 4) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
    }

    //Method to style user work sheet 
    styleUserWorkSheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 30 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);

            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
            };

            // if (cell.r != 1) {
            ws[i].s.border = {
                top: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                bottom: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                left: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                right: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
            };

            if (((cell.r == 1 || cell.r == 2 || cell.r == 3 || cell.r == 4 || cell.r == 5) && cell.c == 0) || cell.r == 8) {
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
                ws[i].s.font.bold = true;
            }

            if (ws[i].v === "Total Hours") {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
    }

    //Method to create work sheet for one user
    async createWorksheetForOneUser(
        timesheets: TimeSheetDto[],
        timesheetFrequency: ProjectTimesheetFrequencyEnum,
        projectId: number
    ): Promise<{ worksheet: xlsx.WorkSheet; summary: SummaryTimesheetForUser }> {
        try {
            this._monitorService.logTrace("UI-createWorksheetForOneUser", { "createWorksheetForOneUser ": "createWorksheetForOneUser:action " + this + this.msg + this.dateTime })
            let timesheetJsonArrayForOneUser: TimesheetJson[] = [];

            for (let i = 0; i < timesheets.length; i++) {
                let timesheet = timesheets[i];
                let datesArray = this._tus.getDatesArrayFromFrequency(timesheet, timesheetFrequency);
                let timesheetJsonArray = await this.getTimesheetJsonArray(datesArray, projectId, timesheet, timesheetFrequency);
                timesheetJsonArrayForOneUser = [...timesheetJsonArrayForOneUser, ...timesheetJsonArray];
            }

            let modifiedArray = timesheetJsonArrayForOneUser.map((r) => {
                let x = [];
                x.push(r.dateString);
                x.push(r.taskName);
                x.push(r.EstimatedHours);
                x.push(r.hoursSpent);
                x.push(r.Billability);
                x.push(r.status);
                return x;
            });

            let totalEstimatedTime = modifiedArray.reduce((a, v) => {
                a += this._tus.timestampToMinutes(v[2]);
                return a;
            }, 0);
            let totaltrackedTime = modifiedArray.reduce((a, v) => {
                a += this._tus.timestampToMinutes(v[3]);
                return a;
            }, 0);





            let summaryForUser = new SummaryTimesheetForUser();
            summaryForUser.member = timesheets[0].userName;
            summaryForUser.role = timesheets[0].userRole;
            summaryForUser.totalHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(totaltrackedTime));
            summaryForUser.requiredHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheets[0].requiredHours)));
            summaryForUser.BilledHours = this._tus.trimTimestamp(this._tus.minutesToTimestamp(this._tus.timestampToMinutes(timesheets[0].billedHours)));
            if (timesheets[0].timesheetStatus == 1) {
                summaryForUser.TimeSheetStatus = "Approved";
            }
            else if (timesheets[0].timesheetStatus == 2) {
                summaryForUser.TimeSheetStatus = "Pending";
            }
            else if (timesheets[0].timesheetStatus == 3) {
                summaryForUser.TimeSheetStatus = "Rejected";
            }
            else if (timesheets[0].timesheetStatus == 4) {
                summaryForUser.TimeSheetStatus = "Overdue";
            }

            modifiedArray.unshift(["Date", "Tasks", "Estimated Hours", "Tracked Hours", "Billability", "Status"]);
            modifiedArray.push(["", "Total Hours", this._tus.trimTimestamp(this._tus.minutesToTimestamp(totalEstimatedTime)), this._tus.trimTimestamp(this._tus.minutesToTimestamp(totaltrackedTime))]);

            const ws: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
            xlsx.utils.sheet_add_aoa(ws, [[`Timesheet for ${timesheets[0].userName}`]], { origin: "A2" });
            xlsx.utils.sheet_add_aoa(ws, modifiedArray, { origin: "A3" });
            const merge = [{ s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }];
            ws["!merges"] = merge;
            return { worksheet: ws, summary: summaryForUser };
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Method to get timesheet data in JSON format
    async getTimesheetJsonArray(
        datesArray: Date[],
        projectId: number,
        timesheet: TimeSheetDto,
        timesheetFreq: ProjectTimesheetFrequencyEnum
    ): Promise<TimesheetJson[]> {
        let timesheetJsonArray: TimesheetJson[] = [];

        let d = new Date();

        for (let i = 0; i < datesArray.length; i++) {
            let dateInWeek = datesArray[i];
            let daysInWeek = this._tus.getWeekDateArrayFromWeekRange(this._tus.getWeekRangeFromDate(dateInWeek));
            let dateRange;
            if (timesheetFreq === ProjectTimesheetFrequencyEnum.BiMonthly || timesheetFreq === ProjectTimesheetFrequencyEnum.Monthly) {
                dateRange = this._tus.getTimesheetRangeFromFrequency(
                    datesArray[i],
                    timesheetFreq,
                    timesheetFreq === ProjectTimesheetFrequencyEnum.BiMonthly ? this._tus.getLocalJsDate(timesheet.projectCreationDate) : undefined
                );
            }
            let individualTimesheet = await this._tsProxy
                .getAllMyTimesheetTaskByProjectId(
                    projectId,
                    timesheet.id,
                    timesheet.userId,
                    this._tus.getWeekStringArray(datesArray[i], "DD MMMM YYYY"),
                    dateRange ? DateTime.fromJSDate(dateRange[0]) : undefined,
                    dateRange ? DateTime.fromJSDate(dateRange[1]) : undefined,
                    timesheetFreq,
                    d.getTimezoneOffset()
                )
                .pipe(
                    map((r) => {
                        return r.filter((x) => x.includeInTimesheet);
                    })
                )
                .toPromise();

            for (let i = 0; i < individualTimesheet.length; i++) {
                let oneTaskRow = individualTimesheet[i];
                for (let j = 0; j < 7; j++) {
                    let date = daysInWeek[j];
                    let dateKey = moment(new Date(date.toString())).format("dddd").toLowerCase();
                    if (
                        this._tus.isDateInRange(date, [
                            this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(timesheet.fromDate)),
                            this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(timesheet.toDate)),
                        ])
                    ) {
                        let timesheetJsonObj = new TimesheetJson();
                        timesheetJsonObj.hoursSpent = this._tus.trimTimestamp(oneTaskRow.daysListDtos[0][dateKey]);
                        timesheetJsonObj.dateString = moment(new Date(date.toString())).format("DD-MMM-YYYY");
                        timesheetJsonObj.taskName = oneTaskRow.taskName;
                        timesheetJsonObj.taskId = oneTaskRow.userTaskId;
                        timesheetJsonObj.Billability = oneTaskRow.billabilityStatus == 1 ? "Billable" : "Non-Billable";

                        if (oneTaskRow.taskStatus == 1) {
                            timesheetJsonObj.status = "New";
                        }
                        else if (oneTaskRow.taskStatus == 2) {
                            timesheetJsonObj.status = "Progress";
                        }
                        else if (oneTaskRow.taskStatus == 3) {
                            timesheetJsonObj.status = "Overdue";
                        }
                        else if (oneTaskRow.taskStatus == 4) {
                            timesheetJsonObj.status = "Completed";
                        }
                        var res = await this._tsProxy.getTaskEsstimateHoursByTaskId(oneTaskRow.id).toPromise();
                        timesheetJsonObj.EstimatedHours = this.getHourAndMinutes(res.estimatedHours);
                        if (timesheetJsonArray.findIndex((x) => x.taskId === timesheetJsonObj.taskId) !== -1) {
                            let index = timesheetJsonArray.findIndex((x) => x.taskId === timesheetJsonObj.taskId);
                            let existingTimesheetJsonArray = timesheetJsonArray[index];
                            let existingTimeInMinutes = this._tus.timestampToMinutes(existingTimesheetJsonArray.hoursSpent);
                            let newTimeInMinutes = this._tus.timestampToMinutes(timesheetJsonObj.hoursSpent);
                            let totalTime = existingTimeInMinutes + newTimeInMinutes;
                            let newTimeSpan = this._tus.minutesToTimestamp(totalTime);
                            timesheetJsonArray[index].hoursSpent = newTimeSpan;
                        } else {
                            timesheetJsonArray.push(timesheetJsonObj);
                        }
                    }
                }
            }
        }

        return timesheetJsonArray;
    }

    //Method to get hours and min
    getHourAndMinutes(taskTimeHistory: number): string {

        if (!taskTimeHistory) return "00:00";
        let timeStr = taskTimeHistory.toString();
        let timeSplit = timeStr.split('.');
        if (timeStr.includes('.')) {
            var st = `${timeSplit[0].length > 1 ? timeSplit[0] : '0' + timeSplit[0]}:`;
            let temp = (parseInt(timeSplit[1]) * 60) / (Math.pow(10, timeSplit[1].length));
            if (temp.toString().includes('.')) {
                temp = parseInt(temp.toString().split('.')[0]);
            }
            var st2 = '';
            if (temp > 9) {
                st2 += temp;
            }
            else {
                st2 += '0' + temp;
            }
            return st + st2;
        } else {
            return `${timeStr.length > 1 ? timeStr : '0' + timeStr}:00`;
        }
        return "00:00";
    }

    getFormattedHours(hourString: string): number {
        let timeSplit = hourString.split(':');
        var date = new Date();
        date.setHours(parseInt(timeSplit[0]));
        date.setMinutes(parseInt(timeSplit[1]));
        var coeff = 1000 * 60 * 15;
        var roundedTime = new Date(Math.round(date.getTime() / coeff) * coeff);
        var hrs = roundedTime.getHours();
        var mins = roundedTime.getMinutes();
        //code to convert hours to decimal
        var decimalHours = (hrs + (mins / 60));
        var formattedDecimalHours = decimalHours.toFixed(2)
        return Number(formattedDecimalHours);
    }
    getFormattedHoursAbove24Hrs(hourString: string): number {
        let timeSplit = hourString.split(':');
        var hrs = parseInt(timeSplit[0]);
        var mins = parseInt(timeSplit[1]);
        //code to convert hours to decimal
        var decimalHours = (hrs + (mins / 60));
        var formattedDecimalHours = decimalHours.toFixed(2)
        return Number(formattedDecimalHours);
    }

    //Method to get hours and minutes in string format
    getStringInHourAndMinutes(taskTimeHistory: string): string {

        if (!taskTimeHistory) return "00:00";
        let timeSplit = taskTimeHistory.split('.');
        if (taskTimeHistory.includes('.')) {
            var st = `${timeSplit[0].length > 1 ? timeSplit[0] : '0' + timeSplit[0]}:`;
            let temp = (parseInt(timeSplit[1]) * 60) / (Math.pow(10, timeSplit[1].length));
            if (temp.toString().includes('.')) {
                temp = parseInt(temp.toString().split('.')[0]);
            }
            var st2 = '';
            if (temp > 10) {
                st2 += temp;
            }
            else {
                st2 += '0' + temp;
            }
            return st + st2;
            //st2 = `${timeSplit[1].length > 1 ? (parseInt(timeSplit[1])*60)/(Math.pow(10,timeSplit[1].length)) : '0'+(parseInt(timeSplit[1])*60)/(Math.pow(10,timeSplit[1].length))}`;
        } else {
            return `${taskTimeHistory.length > 1 ? taskTimeHistory : '0' + taskTimeHistory}:00`;
        }
    }

    //Method to get timesheet from a specific date
    getTimesheetFromToDateString(fromDate: DateTime, toDate: DateTime) {
        try {
            this._monitorService.logTrace("UI-getTimesheetFromToDateString", { "getTimesheetFromToDateString ": "getTimesheetFromToDateString:action " + this + this.msg + this.msg + this.dateTime });
            if (
                this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(fromDate)).getTime() ===
                this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(toDate)).getTime()
            ) {
                return moment(new Date(this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(fromDate)))).format("DD MMM YYYY");
            }

            return (
                moment(new Date(this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(fromDate)))).format("DD MMM YYYY") +
                " - " +
                moment(new Date(this._tus.setZeroTimeForLocalDate(this._tus.getLocalJsDate(toDate)))).format("DD MMM YYYY")
            );
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }


    }

    async exportToExcelTimesheetNotFillSheetReport(timesheetDetails: NotFIllTImesheet[], reportName: string) {
        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();
        let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

        xlsx.utils.sheet_add_aoa(overallSummary, [["Unsubmitted Timesheet Report"]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(overallSummary, [["Project Name","Employee Id","Employee Name","Project Role", "Timesheet Date"]], {
            origin: "A2",
        });
        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
          //  let timesheetDate = this.formatDateString(r.timesheetDate.toString(), dateFormat);
            x.push(r.projectName);
            x.push(r.employeeId);
            x.push(r.employeeName);
            x.push(r.projectRole);
            x.push((new Date(r.timesheetDate as any)));
            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A3",
        });

           // Merge and center cells A1 to F1
           overallSummary["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4} }];
        this.styleTimesheetNotFillSheet(overallSummary);

        for (var i in overallSummary) {
            if (typeof overallSummary[i] != 'object') continue;
            let cell = xlsx.utils.decode_cell(i);
            if (cell.c == 7 || cell.c == 6) {
                overallSummary[i].z = '0.00';
            }
            if (cell.c == 5) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
            if (cell.r == 0) {
                overallSummary[i].s.font.bold = true;
                overallSummary[i].s.font.underline = true; 
                overallSummary[i].s.font.sz = 12;
                overallSummary[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "FFFFFF" },

                };
                overallSummary[i].s.alignment = {
                    vertical: "center",
                        horizontal: "center",
                        wrapText: '1',
                }
            }
             // Check if the cell is A2
    if (cell.r ==1) { // A2 corresponds to row 1, column 0 (0-based index)
        overallSummary[i].s.font.bold = true; // Make it bold
        overallSummary[i].s.fill = {
      patternType: "solid",
      fgColor: { rgb: "DDDDDD" },
  };
      }
  
        }

        xlsx.utils.book_append_sheet(wb, overallSummary);

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Unsubmitted Timesheet.xlsx");
        }
    }


        styleTimesheetNotFillSheet(ws: xlsx.WorkSheet) {
            ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
            for (let i in ws) {
                if (typeof ws[i] != "object") continue;
                let cell = xlsx.utils.decode_cell(i);
                ws[i].s = {
                    font: {
                        name: "Calibri",
                        sz: 11,
                        color: { rgb: "000000" },
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                };
    
                if (cell.r == 0) {
                    ws[i].s.font.bold = true;
                    ws[i].s.fill = {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    };
                }
            }
        }
        exportDateWisereportNew(timeOffData: any[], reportName: string) {
            // initialize a new workbook
            try {
                const wb: xlsx.WorkBook = xlsx.utils.book_new();
    
                let overallTimeOffSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
           
                this.createDateWiseNew(timeOffData, overallTimeOffSummary);
                  xlsx.utils.book_append_sheet(wb, overallTimeOffSummary, "Detailed");
                 //                this.NewReport(overallTimeOffSummary)
                // export excel
                if (reportName != null || reportName != undefined) {
                    xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
                }
                else {
                    xlsx.writeFile(wb, "Date Wise Attendance Report.xlsx");
                }
            }
            catch (ex: any) {
                this._monitorService.logException(ex, 2);
            }
        }


        
    createDateWiseNew(employeeData: any[], workSheet: xlsx.WorkSheet) {
        try {

            xlsx.utils.sheet_add_aoa(workSheet, [["Date Wise Attendance Report"]], { origin: "A1" });
            xlsx.utils.sheet_add_aoa(workSheet, [["Date", "Employee Id", "Name", "Email","Role" ,"Productive Time", "Unproductive Time", "Neutral Time", "Active Time", "Offline Time","Private Time","Arrived At","Left At","Late By","Total Time At Work","Idle Time","Early By","Overtime"]], {
                origin: "A4",
            });

            // x.push(r.clock_In_Early_Late ? this.getEarlyLateArrivalTimeFormat(r.clock_In_Early_Late) : "-");
            //     x.push(r.clock_Out_Left_Time ? r.clock_Out_Left_Time : "-");
            //     x.push(r.clock_Out_Early_Late ? this.getEarlyLateLeftTimeFormat(r.clock_Out_Early_Late) : "-");
            let modifiedSummaryArray = employeeData.map((r) => {
                              
                let x = [];
                x.push(new Date(r.reportDate as any));
                x.push(r.employeeId ? r.employeeId : "-");
                x.push(r.userName ? r.userName : "-");
                x.push(r.emailAddress ? r.emailAddress  : "-");
                x.push(r.employeeRole ? r.employeeRole: "-");
                x.push(r.productiveTime ? this.formattedHoursWithTime(r.productiveTime) : this.formattedHoursWithTime("00:00:00"))
                x.push(r.unProductiveTime ? this.formattedHoursWithTime(r.unProductiveTime) : this.formattedHoursWithTime("00:00:00"));
                x.push(r.nuetralTime ? this.formattedHoursWithTime(r.nuetralTime) :this.formattedHoursWithTime("00:00:00"));
                x.push(r.total_Active_Time ? this.formattedHoursWithTime(r.total_Active_Time) :this.formattedHoursWithTime("00:00:00"));
                x.push( r.offlineTime ? this.formattedHoursWithTime(r.offlineTime) :this.formattedHoursWithTime("00:00:00"));
                x.push(r.privateTime ? this.formattedHoursWithTime(r.privateTime) :this.formattedHoursWithTime("00:00:00"));
                x.push(r.clock_In_ArrivalTime ? r.clock_In_ArrivalTime :"00:00:00");
                x.push(r.clock_Out_Left_Time ? r.clock_Out_Left_Time :"00:00:00");
                x.push(!r.clock_In_Early_Late.includes("-")? this.formattedHoursWithTime(r.clock_In_Early_Late.replace(/-/g, "")) :  this.formattedHoursWithTime("00:00:00"));
                x.push(r.totalTimeAtWork ? this.formattedHoursWithTime(r.totalTimeAtWork) : this.formattedHoursWithTime("00:00:00"));
                x.push(r.idleTIme ? this.formattedHoursWithTime(r.idleTIme) : this.formattedHoursWithTime("00:00:00"));
                x.push(r.clock_In_Early_Late.includes("-") ? this.formattedHoursWithTime(r.clock_In_Early_Late.replace(/-/g, "")) : this.formattedHoursWithTime("00:00:00"));
                x.push(r.overTime ? this.formattedHoursWithTime(r.overTime) : this.formattedHoursWithTime("00:00:00"));

                return x;
            });
            
            xlsx.utils.sheet_add_aoa(workSheet, modifiedSummaryArray, {
                origin: "A5",
            });

            this.styleDateWiseNewReport(workSheet) 

             
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    formattedHoursWithTime(hourString: string): number {
        let days;
        const lastIndex = hourString.lastIndexOf('.');
        if (lastIndex > 6) { hourString = hourString.substring(0, lastIndex); }
        if (hourString.includes('.')) days = parseInt(hourString.split(".")[0]) * 24;
        if (days) hourString = hourString.split(".")[1];
        let timeSplit = hourString.split(':');
        var hrs = days ? parseInt(hourString.split(":")[0]) + days : parseInt(hourString.split(":")[0]);
        var mins = parseInt(timeSplit[1]);
        var second = parseInt(timeSplit[2]);
        const fractionOfDay = (hrs * 3600 + mins * 60 + second) / (24 * 3600);
        return fractionOfDay;
    }

    styleDateWiseNewReport(ws: xlsx.WorkSheet) {
        
        ws["!cols"] = [{ width: 11 }, { width: 12 }, { width: 30 }, { width: 30 },{width:20} ,{ width: 14.5 }, { width: 17.5 }, { width: 12 }, { width: 11 }, { width: 11.5 }, { width: 11.5 }, { width: 10.5 }, { width: 9.5 },
            , { width: 17 }
            , { width: 10 }
            , { width: 10 }
            , { width: 10 }
            , { width: 10 }];
        ws["!rows"] = [{ hpt: 20 }];

        for (let i in ws) {
            if (typeof ws[i] != "object") {
                continue;
            }
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center",
                    wrapText: '1', // any truthy value here
                },
            };

            if (cell.r == 2 || cell.r == 3) {
                ws[i].s = {
                    font: {
                        bold: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "000000" },
                        },
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                }
            }

            if (cell.r == 0) {
                ws[i].s = {
                    font: {
                        sz: 15,
                        bold: true,
                        underline: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: '1', // any truthy value here
                    },
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "DDDDDD" },
                    }
                }
                if (cell.r > 4 && cell.c == 0) {
                        
                    ws[i].z = 'dd-mmm-yyyy';
                }  
            }
            if (cell.r > 3 && ((cell.c >= 5 && cell.c <= 10) || (cell.c >= 13 && cell.c <= 17))) {
                ws[i].z = '[h]:mm:ss';
            }
            
        }
        const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 17 } }]
        ws["!merges"] = merge;

        return ws;
    }




    exportToExcelProjectAllocationReport(timesheetDetails: ProjectAllocationReport[], reportName: string) {
        // initialize a new workbook
        const wb: xlsx.WorkBook = xlsx.utils.book_new();
        let overallSummary: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(overallSummary, [["Employee Id","Employee Name","Project", "Project Role", "Start Date",  "End Date","Status"]], {
            origin: "A1",
        });

        let modifiedSummaryArray = timesheetDetails.map((r) => {
            let x = [];
          
            x.push(r.employeeId);
            x.push(r.employeeName);
            x.push(r.projectName);
            x.push(r.projectRole);
            x.push(new Date(r.startDate as any));
            x.push(new Date(r.endDate as any));
            const endDate = new Date(r.endDate as any);
            const today = new Date();
            if (endDate <= today)
                 {
                x.push("Un Allocated");

                 }
            else{

                x.push("Allocated");
            }
       
            return x;
        });
        xlsx.utils.sheet_add_aoa(overallSummary, modifiedSummaryArray, {
            origin: "A2",
        });

        this.styleProjectAllocationSheet(overallSummary);

        for (var i in overallSummary) {
            if (typeof overallSummary[i] != 'object') continue;
            let cell = xlsx.utils.decode_cell(i);
            if (cell.c == 4) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
          
            if (cell.c == 5) {
                overallSummary[i].z = 'dd-mmm-yyyy';
            }
  
        }

        xlsx.utils.book_append_sheet(wb, overallSummary);

        // export excel
        if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Project Allocation Report.xlsx");
        }
    }
	
	
	
	styleProjectAllocationSheet(ws: xlsx.WorkSheet) {
        ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },{ width: 20 }];
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);
            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };

            if (cell.r == 0) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
    }


    createmonthwisesheet( monthkeyvalue :Root, reportName: string) {
        const wb: xlsx.WorkBook = xlsx.utils.book_new();

        for (const [month, records] of Object.entries(monthkeyvalue)) {
            let overallAttendance: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);

            this.createExcelReport(overallAttendance,wb,records, month);
            xlsx.utils.book_append_sheet(wb, overallAttendance, month);
            
          }

          if (reportName != null || reportName != undefined) {
            xlsx.writeFile(wb, `${_.capitalize(reportName)}.xlsx`);
        }
        else {
            xlsx.writeFile(wb, "Projection vs ActualReport.xlsx");
        }
            //
            // this.createOverallAttendanceSheet(overallAttendance, timesheetDetails.attendanceReportOverAllSummaryDto, month);
            // xlsx.utils.book_append_sheet(wb, overallAttendance, month);
            // this.styleOverallAttendanceSheet(overallAttendance);
      
    }


    createExcelReport(overallAttendance: xlsx.WorkSheet ,workbook:xlsx.WorkBook,timesheetDetails: NewProjectAllocation[], monthname: string) {
       
        const currentMonthHeader = ["Project Name", "Employee Name", "Model", "PM/DM",  `${monthname}`, "", "", "", "","","","","","","","","","",""];
        xlsx.utils.sheet_add_aoa(overallAttendance, [currentMonthHeader], { origin: "A1" });
        const headers = [
            "", "", "", "",
            "Projected Hours", "", "", "", "",
            "Logged Hours", "", "", "", "",
            "Billable Hours", "", "", "", ""
          ];
        
          const subHeaders = [
            "", "", "Fixed / T&M", "",  
            "P.P1", "P.P2", "P.P3", "P.P4", "Total Projected",
            "L.P1", "L.P2", "L.P3", "L.P4", "Total Logged",
            "B.P1", "B.P2", "B.P3", "B.P4", "Total Billable"
          ];
        const worksheetData = [headers, subHeaders];
        xlsx.utils.sheet_add_aoa(overallAttendance, worksheetData, { origin: "A2" });
      
      let data =   timesheetDetails.map(item => {
        let r = []
         r.push(item.projectName);
            r.push(item.employeeName);
            r.push(item.projectType);
            r.push(item.projectManager);
            r.push(parseFloat(item.projectedHours.p1.toFixed(2)));
            r.push(parseFloat(item.projectedHours.p2.toFixed(2)));
            r.push(parseFloat(item.projectedHours.p3.toFixed(2)));
            r.push(parseFloat(item.projectedHours.p4.toFixed(2)));
            r.push(parseFloat(item.projectedHours.p1.toFixed(2))+ parseFloat(item.projectedHours.p2.toFixed(2))+parseFloat(item.projectedHours.p3.toFixed(2))+parseFloat(item.projectedHours.p4.toFixed(2)));
            r.push(parseFloat(item.loggedHours.p1.toFixed(2)));
            r.push(parseFloat(item.loggedHours.p2.toFixed(2)));
            r.push(parseFloat(item.loggedHours.p3.toFixed(2)));
            r.push(parseFloat(item.loggedHours.p4.toFixed(2)));
            r.push(parseFloat(item.loggedHours.p1.toFixed(2))+parseFloat(item.loggedHours.p2.toFixed(2))+parseFloat(item.loggedHours.p3.toFixed(2))+parseFloat(item.loggedHours.p4.toFixed(2)));
            r.push(parseFloat(item.billedHours.p1.toFixed(2)));
            r.push(parseFloat(item.billedHours.p2.toFixed(2)));
            r.push(parseFloat(item.billedHours.p3.toFixed(2)));
            r.push(parseFloat(item.billedHours.p4.toFixed(2)));
            r.push(parseFloat(item.billedHours.p1.toFixed(2))+parseFloat(item.billedHours.p2.toFixed(2))+parseFloat(item.billedHours.p3.toFixed(2))+parseFloat(item.billedHours.p4.toFixed(2)));
            return r;
        });
        xlsx.utils.sheet_add_aoa(overallAttendance, data, {
            origin: "A4",
        });
    
        const range = xlsx.utils.decode_range(overallAttendance['!ref']);
    for (let R = 3; R <= range.e.r; ++R) {
        for (let C = 0; C <= range.e.c; ++C) {
            const cell_address = { c: C, r: R };
            const cell_ref = xlsx.utils.encode_cell(cell_address);
            if (!overallAttendance[cell_ref]) continue;
            if (!overallAttendance[cell_ref].s) overallAttendance[cell_ref].s = {};
            overallAttendance[cell_ref].s.border = {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            };
        }
    }
        this.styleHeaders(overallAttendance);
      // export excel
      }
       styleHeaders(worksheet: xlsx.WorkSheet) {
           worksheet['!cols'] = [
            { width: 40 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 10 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 15 }, { width: 10 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 15 }, { width: 10 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 15 }
          ];
        const headerStyle: xlsx.CellStyle = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "5A9BD5" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };
        for (let c = 0; c < 20; c++) {
          worksheet[xlsx.utils.encode_cell({ r: 0, c })] = {
            v: worksheet[xlsx.utils.encode_cell({ r: 0, c })]?.v,
            s: headerStyle
          };
        }
        const subHeaderStyle: xlsx.CellStyle = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "5A9BD5" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };
        for (let c = 0; c < 20; c++) {
          worksheet[xlsx.utils.encode_cell({ r: 1, c })] = {
            v: worksheet[xlsx.utils.encode_cell({ r: 1, c })]?.v,
            s: subHeaderStyle
          };
        }

        for (let c = 0; c < 20; c++) {
            worksheet[xlsx.utils.encode_cell({ r: 2, c })] = {
              v: worksheet[xlsx.utils.encode_cell({ r: 2, c })]?.v,
              s: subHeaderStyle
            };
          }

        worksheet["!merges"]
        = [
            { s: {r: 0,c: 0 }, e: { r: 2, c: 0 } },
            { s: {r: 0,c: 1 }, e: { r: 2, c: 1 } },
            { s: {r: 0,c: 2 }, e: { r: 1, c: 2 } },
            { s: {r: 0,c: 3 }, e: { r: 2, c: 3 } },
            { s: {r: 0,c: 4 }, e: { r: 0, c: 18 } },
            { s: {r: 1,c: 4 }, e: { r: 1, c: 8 } },
            { s: {r: 1,c: 9 }, e: {r: 1,c: 13 } },
            { s: {r: 1,c: 14 }, e: {r: 1,c: 18 } },
           ];
      }
      
}    




  
//Classes
export class TimesheetJson {
    constructor() { }
    public dateString: string;
    public taskName: string;
    public hoursSpent: string;
    public taskId: number;
    public EstimatedHours: string;
    public status: string;
    public Billability: string;
}

export class SummaryTimesheetForUser {
    constructor() { }
    public member: string;
    public role: any;
    public totalHours: string;
    public requiredHours: string;
    public BilledHours: string;
    public TimeSheetStatus: string;
}
export interface Root {
    [month: string]: NewProjectAllocation[]; // Dynamic key-value pairs for months
  }
  
export class NewProjectAllocation {
    public employeeName: string;
    public projectName: string;
    public projectType: number;
    public projectManager: string;
    public projectedHours: Hours;
    public loggedHours: Hours;
    public billedHours: Hours;
}

export class Hours {
    public p1: number;
    public p2: number;
    public p3: number;
    public p4: number;
}

export class TimesheetEmployeeReportJson {
    constructor() { }
    public dateString: string;
    public taskName: string;
    public hoursSpent: string;
    public EstimatedHours: string;
    public status: string;
    public Billability: string;
    public timesheetStatus: string;
}

export class TimesheetReportForEmployee {
    constructor() { }
    public member: string;
    public emailAddress: string;
    public totalHours: string;
    public requiredHours: string;
    public BilledHours: string;
    public TimeSheetStatus: string;
}

export class TimeSpan {
    constructor(
      public days: number,
      public hours: number,
      public minutes: number,
      public seconds: number,
      public milliseconds: number
    ) {}
  }

  export class ProjectAllocationReport {
    public projectId: number;
    public projectName: string;
    public employeeName: string;
    public employeeId: string;
    public projectRole: string;
    public startDate: string;
    public endDate: string;
}